import {
  ErrorsI18n,
  HomeI18n,
  I18nData,
  I18nResources,
  LandingI18n,
  type CatalogI18n,
  type DeepPartial,
  type DemoAppI18n,
  type JoinFunnelI18n,
  type MealVouchersI18n,
  type Newsi18n,
  type ProductDetailI18n,
  type ProposalsI18n,
  type SelfRegistrationI18n,
  type ShoppingI18n,
  type TutorialI18n,
  type UserAccountI18n,
  type UserInfoI18n,
} from 'app/src/model'
import { DefaultBodyType, http, HttpResponse } from 'msw'
import { apiBaseUrl } from './commonconfig'

const homeI18nIt: HomeI18n = {
  AppBar: {
    AltLogoImage: 'Logo Poste Welfare Servizi',
    Logout: 'Esci',
    UserInfo: 'I tuoi dati',
    UserAccount: 'Il tuo welfare',
    HowToUsePlatform: 'Come utilizzare la piattaforma',
    Catalog: 'Catalogo',
    Discounts: 'Sconti',
    Landing: 'Home',
    ContactUs: 'Parla con noi',
    DemoSettings: 'Impostazioni',
    ContactUsSubTitle: 'Siamo a disposizione per ogni domanda',
    GotoCatalogSearch: 'Ricerca nel catalogo',
    MealVouchers: 'Buoni pasto',
  },
  Global: {
    Yes: 'Si',
    No: 'No',
    Hello: 'Ciao',
    Minutes: 'minuti',
    Hours: 'ore',
    Days: 'giorni',
    Paginator: {
      LoadMoreLabel: 'Carica altri elementi',
      EmptyMessage: 'Non ci sono elementi da mostrare',
    },
    Loading: {
      Message: 'Caricamento...',
    },
  },
}

const landingI18nIt: LandingI18n = {
  Landing: {
    BannerTitle: 'Il Welfare pensato per TE',
    BannerDescription:
      'PWS Mondo Welfare offre un ecosistema di servizi su misura pensato di ogni azienda. Beni e servizi per mettere al centro le persone .',
    TailBrand: '© Poste Italiane 2024 - Partita IVA: 01114601006',
    PoweredBy: 'powered by',
    ContactUs: {
      Title: 'Parla con noi',
      CardTitle: 'Come possiamo aiutarti?',
      CardSubtitle: 'Se hai domande, bisogno di assistenza o desideri maggiori informazioni, non esitare a contattarci.',
      CardButtonLabel: 'Contattaci',
    },
    HomeHeader: {
      Title: 'Più valore al tuo Premio di Risultato',
      Text: 'Il Welfare aziendale per la conversione del Premio di Risultato in prodotti e servizi di welfare volto ad offrire un reale contributo al miglioramento del benessere delle persone e delle loro famiglie.',
    },
    PartnerCarousel: {
      Title: 'La nostra rete di partner',
    },
    Join: {
      Title: 'Il tuo premio di risultato vale molto di più di quello che credi',
      Text: 'Aderisci ora per non perdere soldi e vantaggi. Hai tempo fino al 7 Luglio 2025.',
      ButtonLabel: 'Verifica il vantaggio e aderisci',
    },
    GoToCatalog: {
      ButtonLabel: 'Vai al catalogo',
    },
    BackToCatalog: {
      ButtonLabel: 'Torna al catalogo',
    },
    BackToDiscount: {
      ButtonLabel: 'Torna agli sconti',
    },
    CheckCatalog: {
      ButtonLabel: 'Consulta il catalogo',
    },
    NewsFeed: {
      Title: 'Notizie',
      ReadMore: 'Leggi la notizia',
      OpenNewsList: 'Vai alla sezione notizie',
    },
    Discount: {
      Title: 'Sconti riservati per te',
      Text: 'Acquistando beni e servizi con il tuo Credito Welfare sul Catalogo Welfare potrai beneficiare anche delle condizioni esclusive riservate dai nostri partner al personale',
    },
    UserSidePanel: {
      Email: 'Email',
      Iban: 'IBAN',
      Familymembers: 'Nucleo Familiare',
      ButtonLabelUserData: 'Gestisci i tuoi dati',
      ButtonLabelExit: 'Esci',
    },
    TimerAndBalance: {
      'pre-join': 'La fase di adesione inizierà tra',
      join: 'La fase di adesione finirà tra',
      'pre-fruition': 'La fase di fruizione inizierà tra',
      fruition: 'La fase di fruizione finirà tra',
      closed: '',
    },
    CampaignSelectionDialog: {
      Title: 'Seleziona il Piano Welfare',
      CancelButtonLabel: 'Annulla',
      ConfirmButtonLabel: 'Conferma',
      from: 'dal',
      to: 'al',
      InformativeText:
        "<div>Se sei abilitato a più Piani Welfare, seleziona quello con cui desideri procedere.<br>Ogni Piano dispone di un credito dedicato e l'importo visualizzato sarà relativo esclusivamente a quello selezionato.<br>Puoi modificare il Piano in qualsiasi momento cliccando sull’icona del profilo in alto a destra.</div>",
    },
    Terms: {
      Title: 'Regolamento',
    },
    BalanceWidget: {
      AvailableBalance: 'Saldo disponibile:',
      ShowBalance: 'Mostra saldo',
      HideBalance: 'Nascondi saldo',
      GoToUserArea: 'Vai al tuo Conto Welfare',
    },
    BalanceReminderDialog: {
      Title: 'Comunicazione per conto welfare residuo',
      ConfirmButtonLabel: 'OK, ho capito',
      ID_1: "Gentile collega,<br> hai ancora a disposizione un conto welfare: anche i piccoli importi possono essere utilizzati in modo semplice e utile! Con il tuo conto puoi ad esempio:<ul><li> - scegliere tra numerose gift card, quali quelle relative alla spesa alimentare o anche al carburante;</li><li>effettuare versamenti di micro importi in previdenza complementare.<br><br>  Per l’utilizzo del conto welfare residuo, ti ricordiamo in ogni caso di verificare la tua situazione alla luce di quanto previsto dalla normativa fiscale. I limiti previsti dalla normativa vigente in materia di fringe benefit fissano un tetto massimo annuale di 1.000 euro per la generalità dei lavoratori e di 2.000 euro per i lavoratori con figli fiscalmente a carico ai sensi dell'art. 12 del TUIR. Al superamento di dette soglie tutti i fringe benefit erogati nell’anno saranno tassati integralmente.",
      ID_2: "Gentile collega,<br> il tuo conto welfare è ancora disponibile: non perdere l’occasione di utilizzarlo al meglio! Con il tuo conto puoi ad esempio: <ul><li> - scegliere gift card in tutte le categorie presenti a catalogo come quelle relative alla spesa alimentare, all'abbigliamento o anche al carburante;</li><li> - attivare abbonamenti editoriali o multimediali;</li><li > - effettuare versamenti in previdenza complementare.<br><br>  Le gift-card hanno 1 anno di validità: avrai tutto il tempo per decidere come utilizzarle al meglio. Per l’utilizzo del conto welfare residuo, ti ricordiamo in ogni caso di verificare la tua situazione alla luce di quanto previsto dalla normativa fiscale. I limiti previsti dalla normativa vigente in materia di fringe benefit fissano un tetto massimo annuale di 1.000 euro per la generalità dei lavoratori e di 2.000 euro per i lavoratori con figli fiscalmente a carico ai sensi dell'art. 12 del TUIR. Al superamento di dette soglie tutti i fringe benefit erogati nell’anno saranno tassati integralmente. <b>Non lasciare inutilizzato il tuo conto welfare residuo: se non ne fruisci, il credito welfare aggiuntivo andrà perso e la quota del premio di risultato sarà inoltre soggetta a tassazione, riducendo il beneficio a tua disposizione.</b>",
      ID_3: "Gentile Collega,<br> il tuo conto welfare è ancora disponibile: non perdere l'occasione di utilizzarlo al meglio! Con il tuo conto puoi ad esempio: <ul><li> - selezionare viaggi brevi o esperienze per il tuo tempo libero;- destinare l’importo a spese sanitarie (visite specialistiche, check-up, ecc.);- scegliere gift card in tutte le categorie presenti a catalogo come quelle relative alla spesa alimentare, al carburante, all'elettronica, all'abbigliamento, al beauty care;<ul><li> - effettuare versamenti consistenti in previdenza complementare, trasformando il credito in un investimento per il futuro.<br><br> Le gift-card hanno 1 anno di validità: avrai tutto il tempo per decidere come utilizzarle al meglio.Per l’utilizzo del conto welfare residuo, ti ricordiamo in ogni caso di verificare la tua situazione alla luce di quanto previsto dalla normativa fiscale. I limiti previsti dalla normativa vigente in materia di fringe benefit fissano un tetto massimo annuale di 1.000 euro per la generalità dei lavoratori e di 2.000 euro per i lavoratori con figli fiscalmente a carico ai sensi dell'art. 12 del TUIR. Al superamento di dette soglie tutti i fringe benefit erogati nell’anno saranno tassati integralmente.<b>Non lasciare inutilizzato il tuo conto welfare residuo: se non ne fruisci, il credito welfare aggiuntivo andrà perso e la quota del premio di risultato sarà inoltre soggetta a tassazione, riducendo il beneficio a tua disposizione.</b>",
      ID_4: "Gentile Collega,<br> il tuo conto welfare è ancora disponibile: trasformalo in un vantaggio concreto per te e la tua famiglia! Con il tuo conto puoi ad esempio:<ul><li> -  sostenere spese sanitarie rilevanti (visite e cure specialistiche, dispositivi medici, ecc.);<ul><li> - selezionare viaggi brevi o esperienze per il tuo tempo libero;<ul><li> - scegliere gift card in tutte le categorie presenti a catalogo come quelle relative alla spesa alimentare, al carburante, all'elettronica, all'abbigliamento, al beauty care o anche a lenti per la vista e montature;<ul><li> - effettuare versamenti consistenti in previdenza complementare, trasformando il credito in un investimento per il futuro.<br><br>  Le gift-card hanno 1 anno di validità: avrai tutto il tempo per decidere come utilizzarle al meglio. Per l’utilizzo del conto welfare residuo, ti ricordiamo in ogni caso di verificare la tua situazione alla luce di quanto previsto dalla normativa fiscale. I limiti previsti dalla normativa vigente in materia di fringe benefit fissano un tetto massimo annuale di 1.000 euro per la generalità dei lavoratori e di 2.000 euro per i lavoratori con figli fiscalmente a carico ai sensi dell'art. 12 del TUIR. Al superamento di dette soglie tutti i fringe benefit erogati nell’anno saranno tassati integralmente. <b>Non lasciare inutilizzato il tuo conto welfare residuo: se non ne fruisci, il credito welfare aggiuntivo andrà perso e la quota del premio di risultato sarà inoltre soggetta a tassazione, riducendo il beneficio a tua disposizione.</b>",
      ID_5: "Gentile Collega,<br> il tuo conto welfare è ancora disponibile: trasformalo in un vantaggio concreto. Con il tuo conto puoi ad esempio:<ul><li> - sostenere spese sanitarie importanti (piccoli interventi chirurgici, dispositivi medici, ecc.) o spese socio assistenziali (servizi domiciliari, di sollievo, centri diurni, ecc)<ul><li> - organizzare viaggi e soggiorni di valore per te e la tua famiglia;<ul><li> - selezionare abbonamenti per attività sportive, iniziative per il tempo libero, education e viaggi studio;<ul><li> - scegliere gift card in tutte le categorie presenti a catalogo come: spesa alimentare, carburante, elettronica, abbigliamento, casa e arredamento o E-commerce;<ul><li> - effettuare versamenti consistenti in previdenza complementare, trasformando il credito in un investimento per il futuro.<br><br>  Le gift-card hanno 1 anno di validità: avrai tutto il tempo per decidere come utilizzarle al meglio. Per l’utilizzo del conto welfare residuo, ti ricordiamo in ogni caso di verificare la tua situazione alla luce di quanto previsto dalla normativa fiscale.<br>  I limiti previsti dalla normativa vigente in materia di fringe benefit fissano un tetto massimo annuale di 1.000 euro per la generalità dei lavoratori e di 2.000 euro per i lavoratori con figli fiscalmente a carico ai sensi dell'art. 12 del TUIR. Al superamento di dette soglie tutti i fringe benefit erogati nell’anno saranno tassati integralmente. <b>Non lasciare inutilizzato il tuo conto welfare residuo: se non ne fruisci, il credito welfare aggiuntivo andrà perso e la quota del premio di risultato sarà inoltre soggetta a tassazione, riducendo il beneficio a tua disposizione.</b>",
      ID_6: "Gentile Collega,<br> hai ancora a disposizione quasi tutto il tuo conto welfare. Con un importo così importante puoi pianificare spese di valore. Non lasciarlo inutilizzato: se non ne fruisci, il credito welfare aggiuntivo andrà perso e la quota del premio di risultato sarà inoltre soggetta a tassazione, riducendo il beneficio a tua disposizione.  Con il tuo conto puoi ad esempio:<ul><li> - sostenere spese sanitarie importanti (piccoli interventi chirurgici, apparecchio dentario, ecc.);<ul><li> - coprire spese socio assistenziali (assistenza domiciliare, residenze per lungodegenza e centri diurni, ecc.);<ul><li> - organizzare viaggi e soggiorni di valore per te e la tua famiglia;<ul><li> - selezionare abbonamenti per attività sportive o iniziative per il tempo libero, education e viaggi studio;<ul><li> - scegliere gift card in tutte le categorie presenti a catalogo come: spesa alimentare, carburante, elettronica, abbigliamento, casa e arredamento o E-commerce;<ul><li>  - effettuare versamenti consistenti in previdenza complementare, trasformando il credito in un investimento per il futuro.<br><br>  Le gift-card hanno 1 anno di validità: avrai tutto il tempo per decidere come utilizzarle al meglio. Per l’utilizzo del conto welfare residuo, ti ricordiamo in ogni caso di verificare la tua situazione alla luce di quanto previsto dalla normativa fiscale. I limiti previsti dalla normativa vigente in materia di fringe benefit fissano un tetto massimo annuale di 1.000 euro per la generalità dei lavoratori e di 2.000 euro per i lavoratori con figli fiscalmente a carico ai sensi dell'art. 12 del TUIR. Al superamento di dette soglie tutti i fringe benefit erogati nell’anno saranno tassati integralmente. ",
      ID_7: "Gentile Collega,<br> hai ancora a disposizione quasi tutto il tuo conto welfare. Con un importo così importante puoi pianificare spese di valore. Non lasciarlo inutilizzato: se non ne fruisci, il credito welfare aggiuntivo andrà perso e la quota del premio di risultato sarà inoltre soggetta a tassazione, riducendo il beneficio a tua disposizione.  Con il tuo conto puoi ad esempio:<ul><li> - sostenere spese sanitarie importanti (piccoli interventi chirurgici, apparecchio dentario, ecc.);<ul><li> - coprire spese socioassistenziali (assistenza domiciliare, residenze per lungodegenza e centri diurni, ecc.);<ul><li> - organizzare viaggi e soggiorni di valore per te e la tua famiglia;<ul><li> - selezionare abbonamenti per attività sportive o iniziative per il tempo libero, education e viaggi studio;<ul><li> - scegliere gift card in tutte le categorie presenti a catalogo come: spesa alimentare, carburante, elettronica, abbigliamento, casa e arredamento o E-commerce;<ul><li>  - effettuare versamenti consistenti in previdenza complementare, trasformando il credito in un investimento per il futuro.<br><br> Le gift-card hanno 1 anno di validità: avrai tutto il tempo per decidere come utilizzarle al meglio. Per l’utilizzo del conto welfare residuo, ti ricordiamo in ogni caso di verificare la tua situazione alla luce di quanto previsto dalla normativa fiscale. I limiti previsti dalla normativa vigente in materia di fringe benefit fissano un tetto massimo annuale di 1.000 euro per la generalità dei lavoratori e di 2.000 euro per i lavoratori con figli fiscalmente a carico ai sensi dell'art. 12 del TUIR. Al superamento di dette soglie tutti i fringe benefit erogati nell’anno saranno tassati integralmente. ",
    },
  },
}

const catalogI18nIt: CatalogI18n = {
  Catalog: {
    InformativeBanner: {
      Title: 'Il miglior modo di gestire il tuo conto Welfare',
      Text: 'PWS Mondo Welfare offre ai dipendenti la possibilità di migliorare il benessere e la qualità di vita, scegliendo di utilizzare il proprio Credito Welfare in una vasta gamma di beni e servizi esenti da tasse e contributi.',
    },
    SuggestAPartnership: {
      Title: 'Aiutaci ad arricchire il catalogo',
      Text: 'Vuoi suggerire una convenzione che stavi cercando e non hai trovato o vuoi contribuire per aumentare il catalogo?',
      ButtonLabel: 'Suggerisci ora',
    },
    CatalogCategories: {
      ButtonLabel: 'Scopri di più',
    },
    CatalogProductList: {
      Title: 'Scarica la lista completa di tutti i prodotti e i servizi',
    },
    Showcase: {
      SearchPlaceholder: 'Cerca nel catalogo',
      SearchDiscountPlaceholder: 'Cerca gli sconti',
      SearchEmptyMessage: 'La ricerca non ha prodotto risultati',
      DataSetChanged: 'Risultati di ricerca aggiornati',
      CloseSearch: 'Chiudi Ricerca',
      Favourites: 'Preferiti',
      Discount: 'Sconti',
      ErrorSearch: 'Attenzione, si è verificato un errore durante la ricerca',
      Map: {
        hideMapLabel: 'Nascondi Mappa',
        restorePositionLabel: 'Ripristina Posizione',
        showMapLabel: 'Mostra Mappa',
        openProductLabel: 'Apri',
        searchByLabel: '<b>Cerca per:</b>',
        searchByAddress: 'Indirizzo',
        searchByProductName: 'Nome',
        distance: '<b>Distanza:</b> {{DISTANCE}} KM',
      },
    },
    FavouritesBanner: {
      Favourites: {
        Title: 'Preferiti',
        Text: 'Consulta i tuoi prodotti preferiti velocemente.',
        ButtonLabel: 'Visualizza',
      },
      PosteXTe: {
        Title: 'PosteXTe',
        Text: 'Scopri i prodotti convenzionati con PosteXTe.',
        ButtonLabel: 'Visualizza',
      },
    },
    Favourites: {
      BreadcrumbLabel: 'Preferiti',
      Title: 'Preferiti',
      Description: 'I prodotti e i servizi scelti da te.',
      SearchPlaceholder: 'Cerca nei preferiti',
      SearchEmptyMessage: 'La ricerca non ha prodotto risultati',
      DataSetChanged: 'Risultati di ricerca aggiornati',
      CloseSearch: 'Chiudi Ricerca',
      EmptyMessage: 'Non ci sono elementi da mostrare',
    },
  },
}

const newsI18nIt: Newsi18n = {
  News: {
    Title: 'Notizie',
    BackHome: 'Home',
    DownloadPdf: 'Scarica pdf',
    DownloadPdfErrorMessage: 'Attenzione, si è verificato un errore durante il download del file',
    OpenDetail: 'Apri dettaglio',
    LoadMore: 'Mostra altre notizie',
  },
}
const userInfoI18nIt: UserInfoI18n = {
  UserInfo: {
    FamilyRelationships: {
      coniuge: {
        label: 'Coniuge o parte dell’unione civile',
        shortLabel: 'Coniuge',
      },
      fratello_sorella: {
        label: 'Fratello/Sorella',
        shortLabel: 'Fratello/Sorella',
      },
      figlio_figlia: {
        shortLabel: 'Figlio/a',
        label: 'Figlio/Figlia',
      },
      suocero_suocera: {
        shortLabel: 'Suocero/a',
        label: 'Suocero/Suocera',
      },
      genitore: {
        shortLabel: 'Genitori, nonni e bisnonni',
        label: 'Genitori, nonni e bisnonni conviventi',
      },
      genero_nuora: {
        shortLabel: 'Genero/nuora',
        label: 'Genero/nuora',
      },
      genitore_convivente: {
        shortLabel: 'Ascendenti conviventi',
        label: 'Ascendenti conviventi',
      },
      genitore_percettore: {
        shortLabel: 'Ascendenti percettori di assegni alimentari',
        label: 'Ascendenti percettori di assegni alimentari',
      },
    },
    UserPropertyForm: {
      ValidationMessages: {
        Format: {
          Email: 'Inserisci una email valida',
          Iban: 'Inserisci un IBAN valido',
        },
        Required: {
          Email: 'Il campo email è obbligatorio',
          Iban: 'Il campo IBAN è obbligatorio',
        },
      },
      InputPlaceholder: 'Inserisci ...',
      Update: 'Salva',
      Cancel: 'Annulla',
      Errors: {
        userEmail: {
          BadRequestError: "Attenzione, controllare il formato dell'email inserita",
          GenericSaveError: "Attenzione, si è verificato un errore durante la modifica dell'email",
        },
        userIban: {
          BadRequestError: "Attenzione, controllare il formato dell'IBAN inserito",
          GenericSaveError: "Attenzione, si è verificato un errore durante la modifica dell'iban",
        },
      },
    },
    UserDataCard: {
      Update: 'Modifica',
    },
    InformativeBannerSection: {
      Title: 'Innalzamento tetto fringe benefit',
      Text: 'Ti ricordiamo che, come previsto dalla Legge di Bilancio 2025/2027, il limite annuo fringe benefit è pari a 1.000€ per dipendenti che non hanno figli a carico mentre per i dipendenti che hanno figli a carico è pari a 2.000€. Sarà la tua azienda a comunicare eventuali innalzamenti e/o limiti.',
    },
    SimpleTextSection: {
      Text: 'Di seguito il riepilogo dei tuoi dati personali che possono essere da te modificati in qualsiasi momento. Si precisa che il dichiarante si assume la responsabilità in merito alla veridicità dei dati inseriti.',
    },
    FamilyMembersSection: {
      Title: 'Nucleo Familiare',
      ButtonLabel: 'Aggiungi familiare',
    },
    FamilyTable: {
      Errors: {
        DownloadPrivacyFileError: 'Attenzione, si è verificato un errore durante il download del Documento Privacy',
      },
      AriaLabels: {
        DownloadAction: 'Scarica Documento Privacy del Familiare',
      },
      NameAndSurname: 'Nome e Cognome',
      PrivacyDocumentLabel: 'Documento Privacy',
      NoFamilyMembersYet: 'Non hai aggiunto nessun familiare al tuo nucleo',
      NameLabel: 'Nome',
      SurnameLabel: 'Cognome',
      FiscalCodeLabel: 'Codice Fiscale',
      DependentLabel: 'Fiscalmente a carico',
      ParentageLabel: 'Grado parentela',
      UpdateLabel: 'Modifica',
      DeleteLabel: 'Elimina',
      SuccessMessage: 'Operazione completata con successo',
      ErrorMessage: "Attenzione, si è verificato un errore durante l'eliminazione familiari",
      DeleteFamilyMemberTitle: 'Elimina Familiare',
      DeleteFamilyMemberMessage: 'Sei sicuro di voler eliminare questo familiare?',
      MemberAssociatedErrorMessage: "L'utente non può essere eliminato in quanto è associato ad un ordine",
    },
    FamilyForm: {
      ValidationMessages: {
        Custom: {
          FiscalCodeEqualsToRequestor: 'Il campo codice fiscale deve essere diverso da quello del dichiarante',
          FiscalCodeNotUnique: 'Il campo codice fiscale deve essere diverso da quelli già inseriti',
        },
        Required: {
          FirstName: 'Il campo nome è obbligatorio',
          LastName: 'Il campo cognome è obbligatorio',
          FiscalCode: 'Il campo codice fiscale è obbligatorio',
          Relationship: 'Seleziona un grado di parentela',
          TaxDependent: 'Seleziona un valore per il campo fiscalmente a carico',
        },
        Max: {
          FirstName: 'Il campo nome non può avere più di {{CHARCOUNT}} caratteri',
          LastName: 'Il campo cognome non può avere più di {{CHARCOUNT}} caratteri',
        },
        Min: {
          FirstName: 'Il campo nome deve avere almeno {{CHARCOUNT}} caratteri',
          LastName: 'Il campo cognome deve avere almeno {{CHARCOUNT}} caratteri',
          FiscalCode: 'Il campo codice fiscale deve avere almeno {{CHARCOUNT}} caratteri',
        },
        Format: {
          FirstName: 'Il campo nome ha un formato non valido',
          LastName: 'Il campo cognome ha un formato non valido',
          FiscalCode:
            'Codice fiscale non valido. Inserire 16 caratteri alfanumerici in maiuscolo (A–Z, 0–9), senza spazi né simboli. Controllare la coerenza con nome e cognome.',
        },
      },
      SaveErrors: {
        NoDataModified: 'Modifica almeno uno dei campi per effettuare il salvataggio',
        BadRequest: 'Attenzione, controllare il formato dei dati inseriti',
        AddGenericError: 'Attenzione, si è verificato un errore durante il salvataggio',
        UpdateGenericError: 'Attenzione, si è verificato un errore durante il salvataggio',
        PrivacyFileUploadError: 'Attenzione, si è verificato un errore durante il salvataggio del documento Privacy',
      },
      Header: {
        Add: 'Aggiungi Familiare',
        Update: 'Modifica i dati del Familiare',
        AddMessageText: 'Inserisci i dati del familiare che desideri aggiungere',
        UpdateMessageText: 'Modifica i dati del Familiare',
      },
      Body: {
        Form: {
          InputTextPlaceholder: 'Inserisci ...',
          DropdownPlaceholder: 'Seleziona ...',
          DependentLabel: 'Fiscalmente a carico',
          FiscalCodeLabel: 'Codice Fiscale',
          NameLabel: 'Nome',
          ParentageLabel: 'Grado parentela',
          SurnameLabel: 'Cognome',
          AwarenessConditionText:
            'Io sottoscritto, consapevole delle sanzioni penali richiamate dall’art. 76 del D.P.R. 445 del 28.12.2000 per il caso di dichiarazioni non veritiere e di formazione o uso di atti falsi, in relazione ai giustificativi e alle informazioni da me fornite dichiaro che:',
          AwarenessBullets: [
            'I familiari qui riportati possono beneficiare dei servizi di welfare in quanto indicati all’ art.12 del TUIR;',
            'con riferimento ai dati personali dei familiari, ho preso visione dell’informativa privacy relativa al servizio.',
          ],
          ParentBullet: 'il familiare ascendente sopra indicato è con me convivente',
        },
        FileUploader: {
          Title: 'PRIVACY PER LE PRESTAZIONI SANITARIE/SOCIOASSISTENZIALI',
          Description:
            'Consenso al trattamento dei dati personali appartenenti alle particolari categorie di cui all’art.9 del Regolamento 679/2016 UE (c.d. “sensibili”).',
          TemplateButtonLabel: 'Scarica Template',
          SupportedFilesLabel: 'File Supportati:',
          SupportedSizeLabel: 'Dimensione Massima:',
          UploadButtonLabel: 'Carica documento',
          UploadAreaLabel: 'Trascina qui il file da caricare.',
          DeleteButtonLabel: 'Elimina',
          ErrorFileTypeNotSupported: 'Errore: tipologia del file caricato non consentita',
          ErrorFileSizeNotSupported: 'Errore: il file caricato supera le dimensioni consentite',
          ErrorFileLoading: 'Errore durante il caricamento del file',
          ErrorFileDownload: 'Attenzione, si è verificato un errore durante il download del file',
          PrivacyFileName: 'Modulo_per_il_consenso_al_trattamento_dei_dati_particolari.pdf',
        },
        AwarenessCheckboxLabel: 'Accetta le condizioni di cui sopra, quindi procedi al salvataggio del familiare.',
      },
      Footer: {
        Save: 'Salva',
        Cancel: 'Annulla',
      },
    },
  },
}
const productDetailI18nIt: ProductDetailI18n = {
  ProductDetail: {
    facePriceGratis: 'Gratuito',
    descriptionPlaceholder: '(apri link)',
    typologies: {
      giftCard: {
        ButtonLabel: 'Conferma',
      },
      goodAndService: {
        ButtonLabel: 'Continua',
      },
      moneyTransfer: {
        ButtonLabel: 'Procedi',
      },
      pass: {
        ButtonLabel: 'Conferma',
      },
      refund: {
        ButtonLabel: 'Richiedi',
      },
      voucher: {
        ButtonLabel: 'Conferma',
      },
      discount: {
        ButtonLabel: 'Procedi',
      },
    },
    discount: {
      percentage: 'Sconti fino al',
      fixed: 'Sconto di',
      generic: 'Sconto',
      available: 'Sconti disponibili',
    },
    multiPurchaseDescription: 'Scegli la quantità desiderata per ciascun taglio di voucher per procedere con l’acquisto.',
    multiPurchaseTotalDescription: 'Totale',
    productVariantListDropDownTitle: 'Seleziona una tra le possibili scelte',
    addToFavourite: 'Aggiungi ai preferiti',
    removeFromFavourite: 'Rimuovi dai preferiti',
    productVariantListDropDownDescription: 'Scegli tu quanto dedicare del tuo Welfare a questa attività.',
    productVariantNameAriaLabel: 'Importo',
    errorModal: {
      title: 'Errore',
      btnOkLabel: 'Chiudi',
      btnAnagraficaSectionLabel: 'sezione anagrafica',
      p1: 'Per procedere con la tua richiesta, è necessario che per',
      p2: 'tutti i beneficiari selezionati',
      p3: 'il beneficiario selezionato',
      p4: 'venga caricato nella',
      p5: 'il consenso privacy per le prestazioni sanitarie/socioassistenziali.',
      errorMultipurchase:
        'Attenzione, è possibile selezionare al massimo {{MAXVOUCHERTYPECOUNT}} voucher per tipologia e {{MAXVOUCHERCOUNT}} in totale',
    },
    productActivationModal: {
      okBtnLabel: 'Conferma',
      cancelBtnLabel: 'Annulla',
      beneficiarySelectionInfo: {
        all: 'tra te e i tuoi familiari',
        dependentChildrenAndSpouse: "tra coniuge/parte dell'unione civile e/o figli fiscalmente a carico",
        employeeAndFamilyMemberDependent: 'tra te e i tuoi familiari a carico',
        familyMember: 'tra i tuoi familiari',
        familyMemberDependent: 'tra i tuoi familiari a carico',
      },
      headerNoFamilyMembers: {
        title: 'Ci dispiace, non ci sono beneficiari idonei alla richiesta',
        btnAnagraficaSectionLabel: 'sezione anagrafica',
        p1: 'Ti invitiamo a verificare i beneficiari aggiunti nella',
        p2: 'e qualora sia necessario potrai aggiungerli',
      },
      headerNotEmployee: {
        title: 'Prima di proseguire...',
        btnAnagraficaSectionLabel: 'sezione anagrafica',
        p1: 'Per procedere seleziona',
        p2: ' i beneficiari',
        p3: ' il beneficiario',
        p4: 'della tua richiesta',
        p5: " e la destinazione d'uso",
        p6: 'Puoi aggiungere i beneficiari dalla pagina dedicata nella',
      },
      headerFinalUsage: {
        title1: 'Prima di proseguire...',
        title2: 'Conferma la richiesta...',
        p: "Per procedere seleziona la destinazione d'uso.",
      },
      headerConfirmTitle: {
        title: 'Conferma la richiesta...',
      },
      showPersonas: {
        btnCancelAriaLabel: 'elimina la selezione del nominativo',
      },
      bodyFamilyMemberSelection: {
        singleMemberTitle: 'BENEFICIARIO DELLA RICHIESTA',
        multipleMemberTitle: 'BENEFICIARI DELLA RICHIESTA',
        multiselectPlaceholder: 'Seleziona ...',
        multiselectEmptyMessage: 'Seleziona ...',
        dropdownPlaceholder: 'Seleziona ...',
      },
      finalUsageSelection: {
        title: "DESTINAZIONE D'USO",
        dropdownPlaceholder: 'Seleziona ...',
      },
      personalDataDiscalimer: {
        title: 'Stai per essere reindirizzato su un sito esterno.',
        description: 'I seguenti dati stanno per essere inviati al fornitore dei servizi:',
      },
      privacyList: {
        title: 'CONSENSI PRIVACY',
        btnInformativaLabel: 'Apri Informativa',
      },
    },
    productPartnership: {
      altPosteXTe: 'Prodotto in partnership PosteXTe',
      goToPosteXTe: 'Vai a PosteXTe',
    },
    Errors: {
      addToFavourite: 'Non è stato possibile aggiungere ai preferiti',
      removeFromFavourite: 'Non è stato possibile rimuovere dai preferiti',
    },
  },
}

const shoppingI18n: ShoppingI18n = {
  SafetyThresholdBox: {
    title: 'Soglia di Monitoraggio Fringe Benefit',
    message: `<div>Quest'anno abbiamo introdotto una soglia di controllo per segnalarti che hai superato il {{FRINGE_THRESHOLD}}% del limite annuo previsto per i Fringe Benefit. Ti ricordiamo che questo limite non tiene conto di altri eventuali benefit di cui potresti usufruire (es. auto aziendale, iscrizione all’albo professionale, "fiocco giallo", ecc.).</div><div class='mt-4 mb-4'><b>Una volta accettato, l'importo richiesto sarà addebitato sul tuo plafond e non sarà possibile annullare l'operazione</b></div></div>`,
    dontShowAgain: 'Accetta e ricorda la mia scelta',
  },
  Direct: {
    Common: {
      pwsLogo: `<div style="font-size: 23px; font-weight: 700; line-height: 28px; color: white; text-align: center;"><b>Poste</b><span style="font-size: 23px; font-weight: 400; line-height: 28px; color: white;">Welfare</span></div>`,
      balanceDescription: 'Saldo Conto Welfare: {{AVAILABLECREDIT}}',
      freeAmount: 'Gratuito',
    },
    GiftCard: {
      cardToActivate: {
        activateCardButtonLabel: 'ATTIVA LA CARD',
        header: `<div><div>Il tuo codice "{{PRODUCTNAME}}"</div><div><b>Da attivare sul sito esterno dell'esercente</b></div></div>`,
        trailer: `<div style="font-size:14px;margin-top:20px">Sarai portato sul sito esterno dell'esercente</div>`,
        informativeBanner: `<div style="text-align:center;margin-top:20px"><div>Per poter essere utilizzata, <b>la gift card deve essere attivata sul sito dell'esercente.</b></div></div>`,
        activationDescriptionFunnelMode: `<div style="text-align:center;margin-top:20px"><div>Puoi farlo subito cliccando su “Attiva la card”.</div><div style="margin-top:10px">Se preferisci, puoi farlo in un secondo momento, accedendo al tuo Conto Welfare o tramite il link che ti abbiamo inviato via mail.</div></div>`,
        activationDescriptionDetailsMode: `<div style="text-align:center;margin-top:20px">Se non lo hai ancora fatto, puoi farlo subito cliccando su “Attiva la card”.</div>`,
        usageButtonLabel: 'Maggiori dettagli',
      },
      cardActive: {
        mainHeader: `<div>Il tuo codice "{{PRODUCTNAME}}"</div>`,
        pinHeader: `<div>Il tuo PIN "{{PRODUCTNAME}}"</div>`,
        getYourGiftCardButtonLabel: 'Ottieni la tua Gift Card',
        informativeBanner: '',
        informativeBannerFunnelMode: `<div style="text-align:center;margin-top:20px">Potrai recuperare le informazioni accedendo al tuo Conto Welfare o tramite il link che ti abbiamo inviato via mail.</div>`,
      },
      cancelOrder: {
        title: 'Annullamento Ordine',
        body: "Confermi di voler procedere con la richiesta di annullamento dell'ordine?",
        cancelButtonLabel: 'Annulla ordine',
        cancelErrorMessage: {
          title: 'La tua richiesta non è stata accettata',
          subtitle:
            'Ti informiamo che non è possibile dare seguito alla tua richiesta, in quanto la procedura di annullamento non è più applicabile a questo ordine',
        },
        cancelSuccessMessage: {
          title: 'La tua richiesta è stata accettata',
          subtitle: 'L’ordine verrà annullato e l’importo corrispondente sarà a breve riaccreditato sul tuo conto welfare',
        },
      },
      almostDoneTitle: 'La tua Gift Card è quasi pronta',
      detailPageTitle: 'Dettaglio Gift Card',
      getYourCodeButtonLabel: 'Ottieni il tuo codice',
      takeInChargeMessage: `<div>
                          <div class='welfareportal-titlecenter'>Complimenti!</div>
                          <div class='welfareportal-titlecenter'>La tua richiesta di Gift Card è stata presa in carico</div>
                          <div class='welfareportal-titlecenter' style='margin-top:30px'>Dove la trovo?</div>
                          <div style='text-align:center;margin-top:10px;'>Qualora l’elaborazione avesse successo, sarà presto disponibile nella sezione del tuo Conto Welfare e ti manderemo anche una email di conferma.</div>
                       </div>`,
      successMessage: `<div>
                          <div class='welfareportal-titlecenter'>Complimenti!</div>
                          <div class='welfareportal-titlecenter'>Ecco la tua Gift Card</div>
                       </div>`,
      requestInFailErrorMessage: `<div>
                          <div class='welfareportal-titlecenter'>La tua richiesta di Gift Card non è andata a buon fine</div>
                          <div style='margin-top:20px;' class='welfareportal-descriptioncenter'>Ti invitiamo a riprovare</div>
                       </div>`,
      requestInProgressTitle: 'Giftcard in Elaborazione',
      requestInProgressDescription: 'Attendi qualche secondo, stiamo elaborando la tua Gift Card. Quasi fatto!',
      loadingInProgressTitle: 'Giftcard in Caricamento',
      loadingInProgressDescription: '',
      loadingInProgressErrorMessage: 'Attenzione, si è verificato un errore durante il caricamento della Gift Card',
      giftCardNotFoundMessage: 'Attenzione, Gift Card non trovata',
      productDescription: 'Gift Card selezionata per',
      priceDescription: 'Importo',
      detailDescription: 'Dettaglio',
      buyerDescription: 'Acquirente',
      usageDestinationDescription: "Destinazione d'uso",
      buyDateDescription: 'Data acquisto',
      expiringDateDescription: 'Data scadenza utilizzo',
      noExpiringDateDescription: 'Nessuna scadenza',
      confirmButtonLabel: 'Conferma',
      orderIdLabel: 'ID Ordine',
      confirmDialog: {
        title: 'Acquisto GiftCard',
        body: "Confermi l'acquisto della GiftCard?",
      },
    },
    Voucher: {
      buyDateDescription: 'Data richiesta',
      buyerDescription: 'Fruitore',
      expiringDateDescription: 'Fruibile entro',
      noExpiringDateDescription: 'Nessuna scadenza fruizione',
      loadingInProgressDescription: '',
      loadingInProgressErrorMessage: 'Attenzione, si è verificato un errore durante il caricamento del Voucher',
      loadingInProgressTitle: 'Voucher in Caricamento',
      priceDescription: 'Importo pacchetto',
      productDescription: 'Pacchetto selezionato',
      voucherCodeDescription: 'Il tuo codice autorizzativo',
      voucherNotFoundMessage: 'Attenzione, Voucher non trovato',
      almostDoneTitle: 'Il tuo Voucher è quasi pronto',
      requestInProgressTitle: 'Voucher in Elaborazione',
      orderIdLabel: 'ID Ordine',
      cancelOrder: {
        title: 'Annullamento Ordine',
        body: "Confermi di voler procedere con la richiesta di annullamento dell'ordine?",
        cancelButtonLabel: 'Annulla ordine',
        cancelErrorMessage: {
          title: 'La tua richiesta non è stata accettata',
          subtitle:
            'Ti informiamo che non è possibile dare seguito alla tua richiesta, in quanto la procedura di annullamento non è più applicabile a questo ordine',
        },
        cancelSuccessMessage: {
          title: 'La tua richiesta è stata accettata',
          subtitle: 'L’ordine verrà annullato e l’importo corrispondente sarà a breve riaccreditato sul tuo conto welfare',
        },
      },
      confirmDialog: {
        title: 'Acquisto Voucher',
        body: "Confermi l'acquisto del Voucher?",
      },
      detailDescription: 'Dettaglio',
      confirmButtonLabel: 'Conferma',
      requestInProgressDescription: 'Attendi qualche secondo, stiamo elaborando il tuo Voucher. Quasi fatto!',
      detailPageTitle: 'Dettaglio Voucher',
      getYourCodeButtonLabel: 'Ottieni il tuo Voucher',
      requestInFailErrorMessage: `<div>
      <div class='welfareportal-titlecenter'>La tua richiesta di Voucher non è andata a buon fine</div>
      <div style='margin-top:20px;' class='welfareportal-descriptioncenter'>Ti invitiamo a riprovare</div>
   </div>`,
      takeInChargeMessage: `<div>
   <div class='welfareportal-titlecenter'>Complimenti!</div>
   <div class='welfareportal-titlecenter'>La tua richiesta di Voucher è stata presa in carico</div>
   <div class='welfareportal-titlecenter' style='margin-top:30px'>Dove la trovo?</div>
   <div style='text-align:center;margin-top:10px;'>Qualora l’elaborazione avesse successo, sarà presto disponibile nella sezione del tuo Conto Welfare e ti manderemo anche una email di conferma.</div>
</div>`,
      successMessage: `<div>
<div class='welfareportal-titlecenter'>Complimenti!</div>
<div class='welfareportal-titlecenter'>Ecco il tuo Voucher</div>
</div>`,
      informativeBannerFunnelMode:
        '<div style="text-align:center;margin-top:20px">Potrai recuperare le informazioni accedendo al tuo Conto Welfare o tramite il link che ti abbiamo inviato via mail.</div>',
      informativeBannerDetailsMode: '',
    },
    MultiVoucher: {
      multivoucherSummaryTitle: 'Voucher PosteWelfare',
      multivoucherSummaryQnt: 'Quantità',
      errorAllFailedMsg1: 'Attenzione!',
      errorAllFailedMsg2: 'È fallita la generazione di tutti i Voucher richiesti',
      errorAnyFailedMsg1: 'Attenzione non tutti i Voucher sono stati generati!',
      errorAnyFailedMsg2: 'Falliti: {{NFAILED}}',
      errorAnyFailedMsg3: '{{NOK}} correttamente generati:',
      buyDateDescription: 'Data richiesta',
      buyerDescription: 'Fruitore',
      expiringDateDescription: 'Fruibile entro',
      noExpiringDateDescription: 'Nessuna scadenza fruizione',
      loadingInProgressDescription: '',
      loadingInProgressErrorMessage: 'Attenzione, si è verificato un errore durante il caricamento del Voucher',
      loadingInProgressTitle: 'Voucher in Caricamento',
      priceDescription: 'Importo pacchetto',
      productDescription: 'Pacchetto selezionato',
      voucherCodeDescription: 'Il tuo codice autorizzativo',
      voucherNotFoundMessage: 'Attenzione, Voucher non trovato',
      almostDoneTitle: 'Il tuo Voucher è quasi pronto',
      requestInProgressTitle: 'Voucher in Elaborazione',
      orderIdLabel: 'ID Ordine',
      confirmDialog: {
        title: 'Acquisto Voucher',
        body: "Confermi l'acquisto del Voucher?",
      },
      detailDescription: 'Dettaglio',
      confirmButtonLabel: 'Conferma',
      requestInProgressDescription: 'Attendi qualche secondo, stiamo elaborando il tuo Voucher. Quasi fatto!',
      detailPageTitle: 'Dettaglio Voucher',
      getYourCodeButtonLabel: 'Ottieni il tuo Voucher',
      requestInFailErrorMessage: `<div>
      <div class='welfareportal-titlecenter'>La tua richiesta di Voucher non è andata a buon fine</div>
      <div style='margin-top:20px;' class='welfareportal-descriptioncenter'>Ti invitiamo a riprovare</div>
   </div>`,
      takeInChargeMessage: `<div>
   <div class='welfareportal-titlecenter'>Complimenti!</div>
   <div class='welfareportal-titlecenter'>La tua richiesta di Voucher è stata presa in carico</div>
   <div class='welfareportal-titlecenter' style='margin-top:30px'>Dove la trovo?</div>
   <div style='text-align:center;margin-top:10px;'>Qualora l’elaborazione avesse successo, sarà presto disponibile nella sezione del tuo Conto Welfare e ti manderemo anche una email di conferma.</div>
</div>`,
      successMessageMsg1: 'Complimenti!',
      successMessageMsg2: 'Ecco i tuoi voucher',
      informativeBannerFunnelMode:
        '<div style="text-align:center;margin-top:20px">Potrai recuperare le informazioni accedendo al tuo Conto Welfare o tramite il link che ti abbiamo inviato via mail.</div>',
      informativeBannerDetailsMode: '',
      Usage: {
        Errors: {
          UnrecognizedKind: 'Attenzione, tipologia di richiesta di pagamento non riconosciuta',
          RequestGenericError: 'Attenzione, errore durante la richiesta di pagamento.',
          Required: {
            customExternalKey: 'Il campo "{{KEY}}" è obbligatorio',
          },
          Matches: {
            customExternalKey:
              "L'importo inserito non è valido. Inserire una cifra valida (numero intero o numero con una o due cifre decimali) Esempi: 100 - 100,14 - 100,1",
          },
          Custom: {
            customExternalKey: `La somma dell'importo richiesto e "{{LABEL}}" non può superare l'importo totale`,
          },
        },
        Kinds: {
          'poste-energia': {
            Errors: {
              Custom: {
                domiciliationBlocking:
                  'Ci dispiace, il pagamento della fattura non avviene tramite domiciliazione bancaria. Non è possibile effettuare il pagamento con i voucher PosteWelfare',
                expired:
                  'Ci dispiace, la fattura risulta scaduta. Non è possibile effettuare il pagamento con i voucher PosteWelfare',
                expiring:
                  'Ci dispiace, la fattura risulta in scadenza. Non è possibile effettuare il pagamento con i voucher PosteWelfare',
              },
              Matches: {
                invoiceTotal:
                  "L'importo inserito non è valido. Inserire una cifra valida (numero intero o numero con una o due cifre decimali) Esempi: 100 - 100,14 - 100,1",

                requestedRefund:
                  "L'importo inserito non è valido. Inserire una cifra valida (numero intero o numero con una o due cifre decimali) Esempi: 100 - 100,14 - 100,1",
              },
              Max: {
                invoiceDate: 'La data della ricevuta deve essere uguale o antecedente alla data di oggi',
                requestedRefundNumber: "L'importo inserito non deve superare l'importo totale del documento",
              },
              Min: {
                invoiceTotalNumber: "L'importo inserito deve essere maggiore di 0",
                requestedRefundNumber: "L'importo da pagare deve essere maggiore di 0",
              },
              Required: {
                customerId: 'Il campo "codice cliente" è obbligatorio',
                domiciliation: 'Il campo "metodo di pagamento" è obbligatorio',
                dueDate: 'Il campo "data scadenza" è obbligatorio',
                invoiceDate: 'Il campo "data documento" è obbligatorio',
                invoiceId: 'Il campo "numero documento" è obbligatorio',
                invoiceTotal: 'Il campo "importo totale bolletta" è obbligatorio',
                requestedRefund: 'Il campo "importo da pagare" è obbligatorio',
              },
            },
            SubCategories: {
              '1': {
                contractIdLabel: 'POD',
                contractIdFieldName: 'pod',
                invoiceDisclaimer:
                  "L'importo da pagare della bolletta per la fornitura della luce non include l'eventuale Canone TV.",
                Errors: {
                  Required: {
                    contractId: 'Il campo "pod" è obbligatorio',
                  },
                },
              },
              '2': {
                contractIdLabel: 'PDR',
                contractIdFieldName: 'pdr',
                invoiceDisclaimer: '',
                Errors: {
                  Required: {
                    contractId: 'Il campo "pdr" è obbligatorio',
                  },
                },
              },
            },
            DomiciliationOptions: [
              { key: 'true', text: 'Domiciliazione conto corrente' },
              { key: 'false', text: 'Bollettino' },
            ],
            domiciliationOptionsPlaceholder: 'Seleziona un valore...',
          },
          'poste-fibra': {
            Errors: {
              Custom: {
                domiciliationBlocking:
                  'Ci dispiace, il pagamento della fattura non avviene tramite domiciliazione bancaria. Non è possibile effettuare il pagamento con i voucher PosteWelfare',
                expired:
                  'Ci dispiace, la fattura risulta scaduta. Non è possibile effettuare il pagamento con i voucher PosteWelfare',
                expiring:
                  'Ci dispiace, la fattura risulta in scadenza. Non è possibile effettuare il pagamento con i voucher PosteWelfare',
              },
              Matches: {
                invoiceTotal:
                  "L'importo inserito non è valido. Inserire una cifra valida (numero intero o numero con una o due cifre decimali) Esempi: 100 - 100,14 - 100,1",

                requestedRefund:
                  "L'importo inserito non è valido. Inserire una cifra valida (numero intero o numero con una o due cifre decimali) Esempi: 100 - 100,14 - 100,1",
              },
              Max: {
                invoiceDate: 'La data della ricevuta deve essere uguale o antecedente alla data di oggi',
                requestedRefundNumber: "L'importo inserito non deve superare l'importo totale del documento",
              },
              Min: {
                invoiceTotalNumber: "L'importo inserito deve essere maggiore di 0",
                requestedRefundNumber: "L'importo da pagare deve essere maggiore di 0",
              },
              Required: {
                customerId: 'Il campo "codice cliente" è obbligatorio',
                domiciliation: 'Il campo "metodo di pagamento" è obbligatorio',
                dueDate: 'Il campo "data scadenza" è obbligatorio',
                invoiceDate: 'Il campo "data documento" è obbligatorio',
                invoiceId: 'Il campo "numero documento" è obbligatorio',
                invoiceTotal: 'Il campo "importo totale bolletta" è obbligatorio',
                requestedRefund: 'Il campo "importo da pagare" è obbligatorio',
                providerId: 'Il campo "identificativo conto" è obbligatorio',
              },
            },
            DomiciliationOptions: [
              { key: 'true', text: 'Domiciliazione conto corrente' },
              { key: 'false', text: 'Bollettino' },
            ],
            domiciliationOptionsPlaceholder: 'Seleziona un valore...',
          },
        },
        Funnel: {
          abortRequestBtnLabel: 'Annulla la richiesta',
          requestInProgressDescription: 'Attendi qualche secondo, stiamo elaborando la tua richiesta di Pagamento. Quasi fatto!',
          goBackBtnLabel: 'Torna indietro',
          continueBtnLabel: 'Continua',
          confirmBtnLabel: 'Conferma',
          invoiceUploadBtnLabel: 'Carica documento',
          wizardTitle: 'Step {{STEPNUMBER}} di {{STEPCOUNT}}',
          Dialogs: {
            Abort: {
              body: 'Vuoi annullare la richiesta di pagamento?',
              title: 'Annulla richiesta pagamento',
            },
            Confirm: {
              body: 'Vuoi confermare la richiesta di pagamento?',
              title: 'Conferma richiesta pagamento',
            },
            AdditionalDocuments: {
              okButtonLabel: 'OK, ho capito',
              requestButtonLabel: 'eventuali documenti da caricare',
              title: 'Eventuali documenti da caricare',
              requestButtonLabelPrefix: 'Prima di procedere con la tua richiesta, ti invitiamo a verificare gli',
            },
          },
          Steps: {
            InvoiceUpload: {
              title: 'Carica la bolletta di {{REFUNDCATEGORY}} per cui intendi effettuare il pagamento',
              descriptionPrefix: '',
            },
            InvoiceUpdate: {
              title: 'Dati del giustificativo di spesa',
              descriptionPrefix: '',
              description: '<p>Verifica i dati che abbiamo recuperato dalla tua ricevuta. Correggili se necessario.</p>',
              FormFields: {
                Labels: {
                  documentDate: 'Data Documento',
                  customerId: 'Codice Cliente',
                  domiciliation: 'Metodo di pagamento',
                  dueDate: 'Data Scadenza',
                  Fiber: {
                    providerId: 'Identificativo Conto',
                  },
                  documentId: 'Numero Documento',
                  invoiceTotal: 'Importo Totale Documento',
                  requestedRefund: 'Importo Rimborso Richiesto',
                  placeholder: 'Inserisci',
                  dateFormatPlaceholder: 'GG/MM/AAAA',
                  dateFormat: 'dd/mm/yy',
                  formTrailer: '',
                },
              },
            },
            AdditionalDocumentsUpload: {
              title: 'Ulteriore documentazione',
            },
            VoucherSelection: {
              title: `Seleziona i Voucher PosteWelfare che vuoi utilizzare per pagare la bolletta di {{REFUNDCATEGORY}}`,
              description: "Prima di procedere assicurati che la somma dei voucher selezionati copra l'importo da pagare",
              yourVoucherDescription:
                '<div><p><b>I tuoi voucher PosteWelfare</b></p><p>Scegli i tuoi voucher PosteWelfare che vuoi utilizzare per procedere con il pagamento della tua bolletta</p></div>',
              voucherCounterTitle: 'Voucher PosteWelfare',
              availableVouchers: 'Disponibili',
              usedVouchers: 'Utilizzati',
              decreaseVoucherAriaLabel: 'Aggiungi un Voucher da {{VOUCHERVALUE}}',
              increaseVoucherAriaLabel: 'Elimina un Voucher da {{VOUCHERVALUE}}',
              amountToPayLabel: '<b>Importo Bolletta:</b>',
              totalLabel: '<b>Totale:</b>',
              voucherCounterOverviewTable: '<b>Voucher PosteWelfare:</b>',
            },
            ConfirmationStep: {
              title: 'La tua richiesta di pagamento è quasi pronta',
              productDescription: 'Servizio richiesto per',
              balanceDescription: 'Saldo Conto Welfare: {{AVAILABLECREDIT}}',
              priceDescription: 'Importo',
              DetailBox: {
                beneficiaryNameSurname: 'Beneficiario della richiesta',
                beneficiaryFiscalCode: 'CF Beneficiario della richiesta',
                requestDate: 'Data Richiesta',
                documentDate: 'Data Documento',
                invoiceId: 'Numero Documento',
                requestedRefund: 'Importo Bolletta da pagare',
                voucherAmount: 'Voucher PosteWelfare',
                invoiceTotal: 'Importo Totale Documento',
                title: 'Dettaglio',
                vendorName: "Nome dell'Esercente",
                vendorTaxId: "Partita IVA dell'Esercente",
                privacyStatement: 'Accetta le condizioni di cui sopra, quindi conferma la richiesta di pagamento',
              },
            },
            SuccessStep: {
              trailer:
                '<div style="font-weight:bold"><p>Complimenti!</p><p>Richiesta di pagamento avvenuta con successo.</p></div>',
              footer:
                '<div style="margin-top: 20px;"><p>Puoi visualizzare la tua richiesta nella pagina relativa al tuo Conto Welfare.</p><p class="margin-top:10px">Saranno effettuate le verifiche e ti avviseremo tramite una mail dell’esito della tua richiesta.</p></div>',
            },
          },
        },
        Detail: {
          loadingInProgressDescription: '',
          loadingInProgressErrorMessage: 'Attenzione, si è verificato un errore durante il caricamento della Richiesta',
          loadingInProgressTitle: 'Richiesta in Caricamento',
          notFoundMessage: 'Attenzione, Richiesta non trovata',
          invoiceDescription: 'Bolletta Caricata',
          priceDescription: 'Importo',
          title: 'Dettaglio Richiesta',
          buyerDescription: 'Beneficiario della Richiesta',
          detailDateDescription: 'Data Richiesta',
          documentNumberDescription: 'Numero Documento',
          documentDateDescription: 'Data Documento',
          documentExpirationDescription: 'Data Scadenza',
          koOutcomeMessage: 'La tua richiesta di pagamento ha avuto esito negativo.',
          koOutcomeWithReasonMessage: 'La tua richiesta di pagamento è stata rifiutata con la seguente motivazione:',

          documentAmountDescription: 'Importo Totale Documento',
        },
        Request: {
          loadingInProgressDescription: '',
          loadingInProgressErrorMessage: 'Attenzione, si è verificato un errore durante il caricamento della Richiesta',
          loadingInProgressTitle: 'Richiesta in Caricamento',
          notFoundMessage: 'Attenzione, Richiesta non trovata',
        },
      },
    },
    GoodAndService: {
      buyDateDescription: 'Data richiesta',
      buyerDescription: 'Fruitore',
      loadingInProgressDescription: '',
      loadingInProgressErrorMessage: 'Attenzione, si è verificato un errore durante il caricamento del Voucher',
      loadingInProgressTitle: 'Voucher in Caricamento',
      priceDescription: 'Importo pacchetto',
      productDescription: 'Pacchetto selezionato',
      voucherCodeDescription: 'Il tuo codice autorizzativo',
      voucherNotFoundMessage: 'Attenzione, Voucher non trovato',
      almostDoneTitle: 'Il tuo Voucher è quasi pronto',
      requestInProgressTitle: 'Voucher in Elaborazione',
      orderIdLabel: 'ID Ordine',
      cancelOrder: {
        title: 'Annullamento Ordine',
        body: "Confermi di voler procedere con la richiesta di annullamento dell'ordine?",
        cancelButtonLabel: 'Annulla ordine',
        cancelErrorMessage: {
          title: 'La tua richiesta non è stata accettata',
          subtitle:
            'Ti informiamo che non è possibile dare seguito alla tua richiesta, in quanto la procedura di annullamento non è più applicabile a questo ordine',
        },
        cancelSuccessMessage: {
          title: 'La tua richiesta è stata accettata',
          subtitle: 'L’ordine verrà annullato e l’importo corrispondente sarà a breve riaccreditato sul tuo conto welfare',
        },
      },
      confirmDialog: {
        title: 'Acquisto Voucher',
        body: "Confermi l'acquisto del Voucher?",
      },
      detailDescription: 'Dettaglio',
      confirmButtonLabel: 'Conferma',
      requestInProgressDescription: 'Attendi qualche secondo, stiamo elaborando il tuo Voucher. Quasi fatto!',
      detailPageTitle: 'Dettaglio Fruizione Diretta',
      detailPageTitleGratis: 'Dettaglio Pacchetto Gratuito',
      detailExternalPurchaseTitleDesc: 'Descrizione: ',
      detailExternalPurchaseTitleId: 'ID: ',
      getYourCodeButtonLabel: 'Ottieni il tuo Voucher',
      takeInChargeMessage: `<div>
      <div class='welfareportal-titlecenter'>Complimenti!</div>
      <div class='welfareportal-titlecenter'>La tua richiesta di Voucher è stata presa in carico</div>
      <div class='welfareportal-titlecenter' style='margin-top:30px'>Dove la trovo?</div>
      <div style='text-align:center;margin-top:10px;'>Qualora l’elaborazione avesse successo, sarà presto disponibile nella sezione del tuo Conto Welfare e ti manderemo anche una email di conferma.</div>
   </div>`,
      requestInFailErrorMessage: `<div>
      <div class='welfareportal-titlecenter'>La tua richiesta di Voucher non è andata a buon fine</div>
      <div style='margin-top:20px;' class='welfareportal-descriptioncenter'>Ti invitiamo a riprovare</div>
   </div>`,
      informativeBannerDetailsMode: '',
      merchantLoginP1: 'Per poter essere utilizzato, ',
      merchantLoginP2: 'dovrai accedere sul sito dell’esercente.',
      merchantLoginP3: 'Puoi farlo subito cliccando su “Accedi”.',
      merchantLoginP4: 'Sarai portato sul sito esterno dell’esercente.',
      merchantLoginBtnLabel: 'Accedi',
      personalDataDiscalimer: {
        title: 'Stai per essere reindirizzato su un sito esterno.',
        description: 'I seguenti dati stanno per essere inviati al fornitore dei servizi:',
      },
      productActivationModal: {
        okBtnLabel: 'Continua',
        cancelBtnLabel: 'Annulla',
        title: 'Prima di proseguire...',
      },
      errorMerchantLogin: 'Errore reindirizzamento al sito esterno',
    },
    StateMapping: {
      confirmed: {
        label: 'Emesso',
      },
      used: {
        label: 'Utilizzato',
      },
      submitted: {
        label: 'Inviato',
      },
      refused: {
        label: 'Rifiutato',
      },
      approved: {
        label: 'Approvato',
      },
      canceled: {
        label: 'Annullato',
      },
    },
    Discount: {
      detailExternalPurchaseTitleDesc: 'Descrizione: ',
      loadingInProgressTitle: 'Codice sconto in Caricamento',
      almostDoneTitle: 'Il tuo codice sconto è quasi pronto',
      loadingInProgressErrorMessage: 'Attenzione, si è verificato un errore durante il caricamento dello sconto',
      requestInProgressTitle: 'Codice sconto in Elaborazione',
      confirmDialog: {
        title: 'Ottieni Codice Sconto',
        body: 'Confermi la richiesta per il codice sconto?',
      },
      voucherCodeDescription: 'Il tuo codice autorizzativo',
      detailDescription: 'Dettaglio',
      buyerDescription: 'Richiedente',
      getYourDiscountButtonLabel: 'Ottieni il tuo codice sconto',
      variantName: 'Tipologia di sconto',
      freeAmount: 'Gratuito',
      confirmButtonLabel: 'Conferma',
      requestInProgressDescription: 'Attendi qualche secondo, stiamo elaborando il tuo codice sconto. Quasi fatto!',
      requestInFailErrorMessage: `<div>
                          <div class='welfareportal-titlecenter'>La tua richiesta di Codice Sconto non è andata a buon fine</div>
                          <div style='margin-top:20px;' class='welfareportal-descriptioncenter'>Ti invitiamo a riprovare</div>
                       </div>`,
      discountToActivate: {
        activateDiscountButtonLabel: 'VAI AL SITO',
        usageButtonLabel: 'Maggiori dettagli',
        header: '<div><b>Accedi alla piattaforma dedicata e scopri gli sconti a te riservati</b></div>',
        trailer: '<div style="font-size:14px;margin-top:20px">Sarai portato sul sito esterno dell\'esercente</div>',
      },
      discountActive: {
        mainHeader: `<div>Il tuo codice "{{PRODUCTNAME}}"</div>`,
        pinHeader: `<div>Il tuo codice sconto "{{PRODUCTNAME}}"</div>`,
        getYourDiscountButtonLabel: 'Ottieni il tuo codice sconto',
      },
      detailPageTitle: 'Dettaglio Codice Sconto',
      getYourCodeButtonLabel: 'Ottieni il tuo codice',
      takeInChargeMessage: `<div>
                          <div class='welfareportal-titlecenter'>Complimenti!</div>
                          <div class='welfareportal-titlecenter'>La tua richiesta per il codice sconto è stata presa in carico</div>
                          <div class='welfareportal-titlecenter' style='margin-top:30px'>Dove la trovo?</div>
                          <div style='text-align:center;margin-top:10px;'>Qualora l'elaborazione avesse successo, sarà presto disponibile nella sezione del tuo Conto Welfare e ti manderemo anche una email di conferma.</div>
                       </div>`,
      successMessage: `<div>
                          <div class='welfareportal-titlecenter'>Complimenti!</div>
                          <div class='welfareportal-titlecenter'>Ecco il tuo codice sconto</div>
                       </div>`,

      discountNotFoundMessage: 'Attenzione, Codice Sconto non trovato',
      productDescription: 'Codice Sconto selezionato per',
      priceDescription: 'Sconto',
      buyDateDescription: 'Data richiesta',
      expiringDateDescription: 'Data scadenza utilizzo',
      noExpiringDateDescription: 'Nessuna scadenza',
      orderIdLabel: 'ID Ordine',
      merchantLoginP1: 'Per poter essere utilizzato, ',
      merchantLoginP2: 'dovrai accedere sul sito dell’esercente.',
      merchantLoginP3: 'Puoi farlo subito cliccando su “Accedi”.',
      merchantLoginP4: 'Sarai portato sul sito esterno dell’esercente.',
      merchantLoginBtnLabel: 'Accedi',
      personalDataDiscalimer: {
        title: 'Stai per essere reindirizzato su un sito esterno.',
        description: 'I seguenti dati stanno per essere inviati al fornitore dei servizi:',
      },
      productActivationModal: {
        okBtnLabel: 'Continua',
        cancelBtnLabel: 'Annulla',
        title: 'Prima di proseguire...',
      },
      errorMerchantLogin: 'Errore reindirizzamento al sito esterno',
    },
  },
  Refund: {
    StateMapping: {
      SUBMITTED: {
        label: 'Ricevuto',
      },
      IN_PROGRESS: {
        label: 'In lavorazione',
      },
      REJECTED: {
        label: 'Rifiutato',
      },
      CANCELED: {
        label: 'Annullato',
      },
      REFUNDED: {
        label: 'Approvato',
      },
    },
    Errors: {
      RequestGenericError: 'Attenzione, errore durante la richiesta rimborso.',
      Uploader: {
        uploadGenericError: 'Errore durante il caricamento del file',
        uploadFileTypeError: 'Errore: tipologia del file caricato non consentita',
        deletingGenericError: 'Errore durante la cancellazione del file',
        uploadMaxSizeError: 'Errore: il file caricato supera le dimensioni consentite',
        uploadDocumentsButtonLabel: 'Carica Documenti',
        documentAiTimeOutMessage: "Errore durante l'elaborazione del file caricato, si prega di riprovare",
        documentAiAnalyzeFailedMessage: "Errore durante l'elaborazione del file caricato",
        fileTableTitle: 'Documenti Utili',
        deleteFileLabel: 'Cancella File',
        retryFileLabel: 'Riprova',
        supportedFileTypeAndMaxSize: 'File Supportati: {{SUPPORTEDFILETYPES}}. Dimensione Massima: {{MAXFILESIZE}}',
      },
      Required: {
        invoiceDate: 'Il campo "data documento" è obbligatorio',
        invoiceId: 'Il campo "numero documento" è obbligatorio',
        invoiceTotal: 'Il campo "importo totale documento" è obbligatorio',
        requestedRefund: 'Il campo "importo rimborso richiesto" è obbligatorio',
        vendorName: `Il campo "nome dell'esercente" è obbligatorio`,
        vendorTaxId: `Il campo "partita IVA dell'esercente" è obbligatorio`,
        welfareCredit: 'Errore nella lettura del saldo Welfare',
        customExternalKey: 'Il campo "{{KEY}}" è obbligatorio',
      },
      Max: {
        invoiceDate: 'La data della ricevuta deve essere uguale o antecedente alla data di oggi',
        requestedRefund: `L'importo inserito non deve superare l'importo totale del documento`,
      },
      Min: {
        invoiceTotal: `L'importo inserito deve essere maggiore di 0`,
        requestedRefund: "L'importo inserito deve essere maggiore di 0",
        welfareCredit: "L'importo inserito supera il Saldo Conto Welfare",
      },
      Matches: {
        invoiceTotal:
          "L'importo inserito non è valido. Inserire una cifra valida (numero intero o numero con una o due cifre decimali) Esempi: 100 - 100,14 - 100,1",
        requestedRefund:
          "L'importo inserito non è valido. Inserire una cifra valida (numero intero o numero con una o due cifre decimali) Esempi: 100 - 100,14 - 100,1",
        customExternalKey:
          "L'importo inserito non è valido. Inserire una cifra valida (numero intero o numero con una o due cifre decimali) Esempi: 100 - 100,14 - 100,1",
        fiscalCode: 'Il codice fiscale inserito non è valido',
      },
      Custom: {
        customExternalKey: `La somma dell'importo richiesto e "{{LABEL}}" non può superare l'importo totale`,
      },
    },
    loadingInProgressDescription: '',
    loadingInProgressErrorMessage: 'Attenzione, si è verificato un errore durante il caricamento della richiesta di Rimborso',
    loadingInProgressTitle: 'Richiesta di Rimborso in Caricamento',
    refundNotFoundMessage: 'Attenzione, Richiesta di Rimborso non trovata',
    refundDetailTitle: 'Dettaglio Rimborso',
    priceDescription: 'Importo rimborso richiesto',
    productDescription: 'Rimborso selezionato per',
    balanceDescription: 'Saldo Conto Welfare: {{AVAILABLECREDIT}}',
    Detail: {
      invoiceDescription: 'Giustificativo di Spesa',
      additionalDocumentsDescription: 'Ulteriore Documentazione',
      orderIdLabel: 'ID Ordine:',
      buyerDescription: 'BENEFICIARIO DELLA RICHIESTA',
      detailDateDescription: 'DATA RICHIESTA',
      documentNumberDescription: 'NUMERO DOCUMENTO',
      documentAmountDescription: 'IMPORTO TOTALE DOCUMENTO',
      documentDateDescription: 'DATA DOCUMENTO',
      vendorTaxIdDescription: "PARTITA IVA DELL'ESERCENTE",
      vendorNameDescription: "NOME DELL'ESERCENTE",
      koOutcomeMessage: 'Il tuo rimborso ha avuto esito negativo.',
      koOutcomeWithReasonMessage: 'La richiesta di rimborso è stata rifiutata con la seguente motivazione:',
      canceledOutcomeMessage: 'La richiesta di rimborso è stata annullata.',
      cancelOrder: {
        title: 'Annullamento Ordine',
        body: "Confermi di voler procedere con la richiesta di annullamento dell'ordine?",
        cancelButtonLabel: 'Annulla ordine',
        cancelErrorMessage: {
          title: 'La tua richiesta non è stata accettata',
          subtitle:
            'Ti informiamo che non è possibile dare seguito alla tua richiesta, in quanto la procedura di annullamento non è più applicabile a questo ordine',
        },
        cancelSuccessMessage: {
          title: 'La tua richiesta è stata accettata',
          subtitle: 'L’ordine verrà annullato e l’importo corrispondente sarà a breve riaccreditato sul tuo conto welfare',
        },
      },
    },
    Funnel: {
      Dialogs: {
        Abort: {
          body: 'Vuoi annullare la richiesta di rimborso?',
          title: 'Annulla richiesta rimborso',
        },
        Confirm: {
          body: 'Vuoi confermare la richiesta di rimborso?',
          title: 'Conferma richiesta rimborso',
        },
        AdditionalDocuments: {
          okButtonLabel: 'OK, ho capito',
          requestButtonLabel: 'eventuali documenti da caricare',
          title: 'Eventuali documenti da caricare',
          requestButtonLabelPrefix: 'Prima di procedere con la tua richiesta, ti invitiamo a verificare gli',
        },
      },
      abortRequestBtnLabel: 'Annulla la richiesta',
      requestInProgressDescription: 'Attendi qualche secondo, stiamo elaborando la tua richiesta di Rimborso. Quasi fatto!',
      goBackBtnLabel: 'Torna indietro',
      continueBtnLabel: 'Continua',
      confirmBtnLabel: 'Conferma',
      invoiceUploadBtnLabel: 'Carica documento',
      wizardTitle: 'Step {{STEPNUMBER}} di {{STEPCOUNT}}',
      Steps: {
        InvoiceUpload: {
          title: 'Carica il giustificativo di spesa',
          descriptionPrefix: '<p>Come prima cosa carica il <b>giustificativo di spesa</b> da te sostenuta.</p>',
        },
        InvoiceUpdate: {
          title: 'Dati del giustificativo di spesa',
          descriptionPrefix: '',
          description: '<p>Verifica i dati che abbiamo recuperato dalla tua ricevuta. Correggili se necessario.</p>',
          FormFields: {
            Labels: {
              documentDate: 'Data Documento',
              documentId: 'Numero Documento',
              invoiceTotal: 'Importo Totale Documento',
              requestedRefund: 'Importo Rimborso Richiesto',
              vendorName: "Nome dell'Esercente",
              vendorTaxId: "Partita IVA dell'Esercente",
              placeholder: 'Inserisci',
              dateFormatPlaceholder: 'GG/MM/AAAA',
              dateFormat: 'dd/mm/yy',
              formTrailer:
                "<span>Prima di procedere, è necessario inserire in piattaforma l'importo che si intende richiedere a rimborso, che può essere uguale o inferiore a quello presente nel documento di spesa, nei limiti del conto welfare individuale.</span>",
            },
          },
        },
        AdditionalDocumentsUpload: {
          title: 'Ulteriore documentazione',
        },
        ConfirmationStep: {
          title: 'La tua richiesta di rimborso è quasi pronta',
          DetailBox: {
            beneficiary: 'Beneficiario della richiesta',
            documentDate: 'Data Documento',
            invoiceId: 'Numero Documento',
            invoiceTotal: 'Importo Totale Documento',
            title: 'Dettaglio',
            customerTaxId: 'Partita IVA',
            vendorName: "Nome dell'Esercente",
            vendorTaxId: "Partita IVA dell'Esercente",
            privacyStatement: 'Accetta le condizioni di cui sopra, quindi conferma la richiesta di rimborso',
          },
        },
        SuccessStep: {
          trailer: '<div style="font-weight:bold"><p>Complimenti!</p><p>Richiesta di rimborso avvenuta con successo.</p></div>',
          footer:
            '<div style="margin-top: 20px;"><p>Puoi visualizzare la tua richiesta nella pagina relativa al tuo Conto Welfare.</p><p class="margin-top:10px">Saranno effettuate le verifiche e ti avviseremo tramite una mail dell’esito della tua richiesta.</p></div>',
        },
      },
    },
  },
  Transfer: {
    StateMapping: {
      SUBMITTED: {
        label: 'Inviato',
      },
      CONFIRMED: {
        label: 'Eseguito',
      },
      REJECTED: {
        label: 'Rifiutato',
      },
      CANCELED: {
        label: 'Annullato',
      },
    },
    abortRequestBtnLabel: 'Annulla la richiesta',
    goBackBtnLabel: 'Torna indietro',
    errorConfirmTitle: 'La tua richiesta di versamento non è andata a buon fine per la seguente motivazione:',
    Detail: {
      title: 'Dettaglio versamento',
      labelImport: 'Importo',
      detailBenecifiaryLabel: 'BENEFICIARIO DELLA RICHIESTA',
      orderIdLabel: 'ID ORDINE:',
      detailDate: 'DATA RICHIESTA VERSAMENTO',
      errorTitle: 'Il tuo versamento ha avuto esito negativo.',
      errorDescription: 'La richiesta di versamento è stata rifiutata con la seguente motivazione:',
    },
    FondoPensione: {
      Errors: {
        ERR_Required: 'Il campo è obbligatorio',
        ERR_SaldoRequired: 'Errore nella lettura del Saldo Conto Welfare',
        ERR_CreditoInsufficiente: "L'importo inserito supera il Saldo Conto Welfare",
        ERR_Importo: "L'importo inserito non è valido. Inserire importo comprensivo di virgola e due decimali. Esempio: 1000,00",
        ERR_Positive: "L'importo inserito deve essere maggiore di zero",
      },
      WizardFristStep: {
        labelStep: 'Step 1 di 2',
        title: "Inserisci l'importo del versamento",
        subtitle: 'Definisci il credito welfare da versare al fondo a cui ti sei iscritto',
        labelProduct: 'DESCRIZIONE FONDO PENSIONE',
        labelImport: 'IMPORTO DA VERSARE',
        creditAvailableLabel: 'Saldo Conto Welfare: ',
        btnLabel: 'Continua',
      },
      WizardSecondStep: {
        labelStep: 'Step 2 di 2',
        title: 'La tua richiesta di versamento è quasi pronta',
        labelProduct: 'Versamento selezionato per',
        labelImport: 'Importo versamento da effettuare',
        creditAvailableLabel: 'Saldo Conto Welfare: ',
        detailTitle: 'Dettaglio',
        detailBenecifiaryLabel: 'BENEFICIARIO DELLA RICHIESTA',
        btnConfirmLabel: 'Conferma',
        btnCancelLabel: 'Annulla la richiesta',
        modalConfirmTitle: 'Vuoi procedere con la richiesta?',
        modalConfirmBtnConfirmLabel: 'Si, confermo',
        modalConfirmBtnCancelLabel: 'No, chiudi',
        modalCancelTitle: 'Vuoi annullare la richiesta e tornare al catalogo?',
        modalCancelBtnConfirmLabel: 'Si, confermo',
        modalCancelBtnCancelLabel: 'No, chiudi',
      },
      WizardFinalStepSubmitted: {
        title: 'Complimenti!',
        subtitle: 'La tua richiesta di versamento è stata effettuata',
        description: 'Ti abbiamo inviato una mail di conferma.',
      },
      WizardErrorGeneric: {
        title: "Attenzione, si è verificato un errore non previsto, contattare l'assistenza tecnica",
        btnRetryLabel: 'Riprova',
        btnGoToCatalogLabel: 'Torna al catalogo',
      },
      cancelOrder: {
        title: 'Annullamento Ordine',
        body: "Confermi di voler procedere con la richiesta di annullamento dell'ordine?",
        cancelButtonLabel: 'Annulla ordine',
        cancelErrorMessage: {
          title: 'La tua richiesta non è stata accettata',
          subtitle:
            'Ti informiamo che non è possibile dare seguito alla tua richiesta, in quanto la procedura di annullamento non è più applicabile a questo ordine',
        },
        cancelSuccessMessage: {
          title: 'La tua richiesta è stata accettata',
          subtitle: 'L’ordine verrà annullato e l’importo corrispondente sarà a breve riaccreditato sul tuo conto welfare',
        },
      },
    },
    FondoSalute: {
      WizardFirstStepWithoutFamilyMembers: {
        title: 'La tua richiesta di versamento è quasi pronta',
        labelProduct: 'Versamento selezionato per',
        labelImport: 'Importo',
        creditAvailableLabel: 'Saldo Conto Welfare: ',
        detailTitle: 'Dettaglio',
        detailBenecifiaryLabel: 'BENEFICIARIO DELLA RICHIESTA',
        btnConfirmLabel: 'Conferma',
        btnCancelLabel: 'Annulla la richiesta',
        modalConfirmTitle: 'Vuoi procedere con la richiesta?',
        modalConfirmBtnConfirmLabel: 'Si, confermo',
        modalConfirmBtnCancelLabel: 'No, chiudi',
        modalCancelTitle: 'Vuoi annullare la richiesta e tornare al catalogo?',
        modalCancelBtnConfirmLabel: 'Si, confermo',
        modalCancelBtnCancelLabel: 'No, chiudi',
      },
      WizardFirstStepWithFamilyMembers: {
        labelStep: 'Step 1 di 2',
        title: 'Dati dei familiari beneficiari della richiesta',
        subtitle: 'Compila i dati dei beneficiari del fondo che hai selezionato per la richiesta di versamento.',
        btnContinueLabel: 'Continua',
      },
      WizardSecondStepWithFamilyMembers: {
        labelStep: 'Step 2 di 2',
        title: 'La tua richiesta di versamento è quasi pronta',
        labelProduct: 'Versamento selezionato per',
        labelImport: 'Importo',
        creditAvailableLabel: 'Saldo Conto Welfare: ',
        detailTitle: 'Dettaglio',
        detailBenecifiaryLabel: 'BENEFICIARIO DELLA RICHIESTA',
        btnConfirmLabel: 'Conferma',
        btnCancelLabel: 'Annulla la richiesta',
        modalConfirmTitle: 'Vuoi procedere con la richiesta?',
        modalConfirmBtnConfirmLabel: 'Si, confermo',
        modalConfirmBtnCancelLabel: 'No, chiudi',
        modalCancelTitle: 'Vuoi annullare la richiesta e tornare al catalogo?',
        modalCancelBtnConfirmLabel: 'Si, confermo',
        modalCancelBtnCancelLabel: 'No, chiudi',
      },
      WizardFinalStepSubmitted: {
        title: 'Complimenti!',
        subtitle: 'La tua richiesta di versamento è stata effettuata',
        description: 'Ti abbiamo inviato una mail di conferma.',
      },
      WizardErrorGeneric: {
        title: "Attenzione, si è verificato un errore non previsto, contattare l'assistenza tecnica",
        btnRetryLabel: 'Riprova',
        btnGoToCatalogLabel: 'Torna al catalogo',
      },
      cancelOrder: {
        title: 'Annullamento Ordine',
        body: "Confermi di voler procedere con la richiesta di annullamento dell'ordine?",
        cancelButtonLabel: 'Annulla ordine',
        cancelErrorMessage: {
          title: 'La tua richiesta non è stata accettata',
          subtitle:
            'Ti informiamo che non è possibile dare seguito alla tua richiesta, in quanto la procedura di annullamento non è più applicabile a questo ordine',
        },
        cancelSuccessMessage: {
          title: 'La tua richiesta è stata accettata',
          subtitle: 'L’ordine verrà annullato e l’importo corrispondente sarà a breve riaccreditato sul tuo conto welfare',
        },
      },
      beneficiaryTitle: 'Familiare Beneficiario ',
      beneficiaryName: 'NOMINATIVO',
      beneficiaryBirthDate: 'DATA DI NASCITA',
      warnBeneficiaryWrongAge:
        'Non è possibile selezionare una data di nascita futura. Si prega di controllare prima di procedere.',
      warnBeneficiaryMaxAge:
        'Non è possibile estendere la copertura sanitaria a figli con più di 26 anni di età. Si prega di controllare prima di procedere.',
    },
    loadingInProgressDescription: '',
    loadingInProgressErrorMessage: 'Attenzione, si è verificato un errore durante il caricamento della Richiesta',
    loadingInProgressTitle: 'Richiesta in Caricamento',
  },
}

const userAccountI18nIt: UserAccountI18n = {
  UserAccountInformativeBannerSection: {
    Description:
      'Scopri come hai utilizzato il tuo Conto Welfare e verifica lo stato delle tue richieste. Consulta i dettagli dei tuoi movimenti per ottenere risposte in tempo reale.',
  },
  WalletOverview: {
    AdditionalCreditUsedText:
      '<b>Credito Welfare aggiuntivo utilizzato: {{ADDITIONALUSEDCREDIT}}</b> su {{TOTALADDITIONALCREDIT}} totali',
    AdditionalCreditSpendingReminderText:
      'Il credito aggiuntivo pari a <strong>{{ADDITIONALAVAILABLECREDIT}}</strong> non utilizzato entro il termine della campagna verrà perso',
    AvailableCreditText: 'Saldo Disponibile: {{AVAILABLECREDIT}}',
    Checkpoint: 'Checkpoint {{CHECKPOINTINDEX}} {{CHECKPOINTAMOUNT}}',
    CheckpointUnlockedAriaLabel: 'Checkpoint {{CHECKPOINTINDEX}} {{CHECKPOINTAMOUNT}} sbloccato',
    CheckpointLockedAriaLabel: 'Checkpoint {{CHECKPOINTINDEX}} {{CHECKPOINTAMOUNT}} bloccato',
    FringeBenefitWidget: {
      SpinnerText:
        '<p>Puoi spendere ancora <strong>{{AVAILABLEFRINGECREDIT}}</strong> in Fringe Benefit (art.51, comma3, T.U.I.R.)</p>',
      Title: 'Residuo fringe Benefit',
    },
    UsedUntilNow: 'Utilizzati ad oggi: {{USEDCREDIT}}',
    PrizeDistribution: {
      totalBonusNonUtilizzato: 'Totale Bonus Non Utilizzato',
      totalBonusUtilizzato: 'Totale Bonus Utilizzato',
      totalPdrNonUtilizzato: 'Totale PDR Non Utilizzato',
      totalPdrUtilizzato: 'Totale PDR Utilizzato',
    },
  },
  FilterSection: {
    FilterBtnLabel: 'Filtri',
    StatusFilterLabel: 'Stato',
    StatusFilterDropdownPlaceholder: 'Stato',
    CampaignFilterLabel: 'Campagna',
    CampaignFilterDropdownPlaceholder: 'Seleziona una Campagna ...',
    DateFormatPlaceholder: 'gg/mm/aaaa',
    RangeLabel: 'Periodo',
    RangeLabelFrom: 'Dal',
    RangeLabelTo: 'Al',
    RangeLabelApplyButton: 'Applica e cerca',
    SortLabel: 'Ordina per:',
    FiltersClearLabelButton: 'Cancella filtri',
    SortAsc: 'Meno recente',
    SortDesc: 'Più recente',
    LastSevenDays: 'Ultimi 7 giorni',
    LastMonth: 'Ultimo mese',
    LastThreeMonths: 'Ultimi 3 mesi',
    TabsLabel: 'Tipologia',
  },
  Tabs: {
    Direct: 'Fruizione diretta',
    Refund: 'Rimborsi',
    MoneyTransfer: 'Versamenti',
    Discount: 'Sconti',
  },
  Direct: {
    PriceLabel: 'IMPORTO',
    SeeDetailsLabel: 'Vedi dettaglio',
  },
  Refund: {
    PriceLabel: 'IMPORTO RIMBORSO',
    SeeDetailsLabel: 'Vedi dettaglio',
  },
  MoneyTransfer: {
    PriceLabel: 'IMPORTO VERSAMENTO',
    SeeDetailsLabel: 'Vedi dettaglio',
  },
  Discount: {
    PriceLabel: 'SCONTO',
    SeeDetailsLabel: 'Vedi dettaglio',
  },
  Prize: {
    Title: 'Prodotto gratuito',
    PriceLabel: '',
    SeeDetailsLabel: 'Vedi dettaglio',
    ClaimPrizeLabel: 'Richiedi',
    ClaimPrizeMsg: 'Complimenti, hai diritto ad un prodotto omaggio.',
  },
}

const tutorialI18it: TutorialI18n = {
  Tutorial: {
    InformativeSection: {
      Title: 'Tutorial piattaforma PWS Mondo Welfare',
      Text: 'Benvenuto nella sezione tutorial del nostro sito web dedicato al Welfare Aziendale. Qui troverai tutte le informazioni necessarie per navigare e utilizzare al meglio il nostro catalogo di prodotti e servizi.',
    },
    MoreInfoSection: {
      Title: 'Ulteriori Informazioni',
      Text: 'Per ulteriori dettagli su come utilizzare al meglio il nostro sistema di Welfare Aziendale o se hai bisogno di assistenza, non esitare a contattare il supporto clienti.',
    },
    HowToSection: {
      Title: 'Come Cercare un Prodotto o Servizio',
      Text: '<ol style="list-style-type: decimal;"><li><b>Accedi al Catalogo:</b> Per iniziare, accedi al nostro catalogo attraverso il menu principale del sito.</li><li><b>Utilizza la Barra di Ricerca:</b> Inserisci parole chiave o nomi specifici di prodotti e servizi nella barra di ricerca per trovare rapidamente ciò che cerchi.</li><li><b>Ricerca nel catalogo:</b> Scrivi ciò di cui hai bisogno e trova esattamente il prodotto di tuo interesse.</li></ol>',
    },
    VideoSection: {
      Title: 'Mini Pillole Video',
      Text: '<p>Abbiamo preparato una serie di mini pillole video, ciascuna di meno di un minuto, per aiutarti a capire meglio come utilizzare i nostri servizi.</p><p>Troverai video su:</p>',
    },
  },
}

const proposalsI18it: ProposalsI18n = {
  Proposal: {
    SuggestSection: {
      Title: 'Suggerisci una convenzione',
      Text: "Se desideri suggerire un esercente o un'attività all'interno di PWS Mondo Welfare, la procedura è semplice.",
    },
    HowToSection: {
      Text: "<ol style=\"list-style-type: decimal;\"><li><b>Verifica la presenza del partner/merchant nel catalogo</b> - Controlla che il partner/merchant non sia già resente tramite la funzione <a href='/#/catalog' target='_blank' rel='noopener noreferrer' class='p-button p-component p-button-link p-button-text underline p-0'>Cerca nel catalogo</a>p.</li><li><b>Proponi il convenzionamento</b> - Seleziona la categoria e inserisci il nome del partner/merchant che desideri proporre.</li><li><b>Ricevi il link da inoltrare</b> - Se l'esito della verifica è positivo riceverai un link da inoltrare, altrimenti una comunicazione con le motivazioni del rifiuto.</li><li><b>Invia il link</b> - Inoltra il link ricevuto al partner/merchant entro 30 giorni; senza invio non sarà possibile procedere.</li><li><b>Attendi la compilazione dei dati</b> - Il partner/merchant inserisce i dati richiesti e carica la documentazione, riceverai promemoria finchè non sarà completa.</li><li><b>Ricevi l'esito finale del convenzionamento</b> - Al termine della valutazione riceverai una comunicazione con l'esito; se positivo, il partner sarà visibile a catalogo.</li></ol>",
      HealthText:
        "<br/> <p>In caso di strutture sanitarie, odontoiatriche, fisioterapiche o di medicina, la segnalazione non deve essere effettuata tramite questo canale. Tali strutture sono invitate a proporre autonomamente la propria candidatura attraverso il seguente link: <a href='https://www.saronweb.it/posteprotezione/homeconvenzionamento' target='_blank' rel='noopener noreferrer' class='p-button p-component p-button-link p-button-text underline p-0'>https://www.saronweb.it/posteprotezione/homeconvenzionamento</a></p>",
    },
    InfoEmailSection: {
      Text: "<p>Ti forniremo <b>un aggiornamento via email</b> sullo stato della tua segnalazione dopo che l'esercente avrà effettuato la richiesta di convenzionamento.</p>",
    },
    CategoriesSection: {
      SuggestCardLabel: '<b>Suggerimento convenzione</b>',
      SearchLabel: 'CATEGORIA',
      SearchLabelSelected: 'Seleziona una categoria',
      InputLabel: "NOME DELL'ESERCENTE",
      InputPlaceholder: 'Inserisci ...',
      ButtonLabel: 'Suggerisci convenzione',
      ModalConfirmBtnConfirmLabel: 'Si, confermo',
      ModalConfirmBtnCancelLabel: 'No, chiudi',
      ModalConfirmTitle: 'Vuoi procedere con la richiesta?',
      ValidationErrorCategory: 'Seleziona una categoria',
      ValidationErrorCompanyName: "Inserisci il nome dell'esercente",
    },
    ProposalsFinalStepSubmitted: {
      Title: 'Complimenti!',
      Subtitle: 'La tua richiesta di convenzionamento è stata effettuata',
      Description:
        "Ti forniremo un aggiornamento via email sullo stato della tua segnalazione dopo che l'esercente avrà effettuato la richiesta di convenzionamento.",
    },
    ProposalsErrorGeneric: {
      Title: 'Attenzione, si è verificato un errore non previsto',
      BtnRetryLabel: 'Riprova',
      BtnGoToCatalogLabel: 'Torna al catalogo',
    },
    InstructionLinkSection: {
      Title: 'Scarica le istruzioni per la compilazione della categoria',
    },
  },
}

const errorsI18It: ErrorsI18n = {
  UnrecoverableErrorMessage: 'Attenzione, si è verificato un errore',
  DownloadFileErrorMessage: 'Attenzione, si è verificato un errore durante il download del file',
  LogoutErrorMessage: 'Attenzione, si è verificato un errore durante il logout',
  HomeBreadCrumb: 'Home',
  UserForbidden: 'Attenzione, non sei abilitato ad accedere ai servizi del Mondo Welfare',
  UserForbiddenTitle: 'Ci dispiace, non puoi accedere a questa pagina',
  UserForbiddenMsgPrefix: 'Potrai qualora tu ne abbia necessit\u00E0, puoi mandare una mail a ',
  UserForbiddenMsgPostfix: ' fornendo anche il tuo contatto telefonico e il tuo codice fiscale.',
  SessionExpiredMsg: 'Sessione Scaduta',
  SessionExpiredBtnLabel: 'Aggiorna',
  SessionExpiredSuggestion: 'Ricarica la pagina oppure clicca su Aggiorna per ripristinare la sessione',
}

const joinFunnelI18It: JoinFunnelI18n = {
  JoinFunnel: {
    Common: {
      titleText: 'Aderisci al Welfare',
      notAvailableText: 'Non disponibile',
      notAvailableDescriptionText: 'Al momento non possiamo fornire una stima del dato',
    },
    FirstStep: {
      title: 'Incrementa il Premio di Risultato, aderisci al Welfare',
      grossCard: {
        moreInfoText: 'Maggiori Dettagli',
        text: 'Stima importo lordo Premio di Risultato',
      },
      convertCard: {
        buttonText: '<span class="font-semibold">Convertendo il {{PERCENTAGE}}</span> del tuo premio di risultato',
        textBeforeFigure: 'Stima importo netto del Premio di Risultato con conversione in Welfare',
        textAfterFigure: '<span class="font-semibold">Tutti</span> nel tuo Conto Welfare',
        netAmountConvertedIntoWelfare: 'di cui, la stima importo netto che troverai nel tuo Conto Welfare è: ',
      },
      doNotConvertCard: {
        buttonText: '<span class="font-semibold">Non convertendo</span> il tuo Premio di Risultato',
        text: 'Se decidi di non aderire al programma Welfare il tuo Premio di Risultato sarà liquidato con la tua busta paga di luglio 2025.',
        textBeforeFigure: 'Stima importo netto in busta paga',
      },
      choosePercentageDialog: {
        title: 'Verifica il valore del tuo Premio di Risultato',
        text: 'Decidi quanto desideri convertire del Premio di Risultato 2024 in beni e servizi welfare.',
        estimateText: 'Stima importo lordo Premio di Risultato',
        percentageDropdownText: 'Percentuale da dedicare al Welfare',
        percentageDropdownPlaceholder: 'Seleziona una percentuale',
        additionalCreditText: 'Credito Welfare Aggiuntivo',
        convertTitle: 'Convertendo il tuo Premio di Risultato',
        convertEstimateText: 'Stima importo netto del Premio di Risultato con conversione in Welfare',
        convertCard: {
          text: 'Stima importo netto convertito in Welfare',
        },
        doNotConvertCard: {
          text: 'Stima importo netto in busta paga',
        },
        abortBtnLabel: 'Annulla',
        confirmBtnLabel: 'Conferma',
        modifyPercentageDialog: {
          title: 'Cambia la tua percentuale di adesione',
          text: 'Sei sicuro di voler modificare la tua percentuale di adesione?',
        },
      },
      modifyPercentageText: 'Se lo desideri, puoi modificare la percentuale di conversione del tuo Premio di Risultato',
      nextBtnLabel: 'Prosegui',
    },
    Confirm: {
      Errors: {
        GenericSaveError: 'Si è verificato un errore durante la richiesta',
      },
      title: 'La tua scelta di adesione',
      convertSection: {
        textBeforeFigure: 'La percentuale del tuo Premio che hai deciso di convertire nel Welfare è:',
        percentageDescription: 'del Premio di Risultato',
        textAfterFigure: 'Potrai sempre modificare la percentuale prima della chiusura della fase di fruizione.',
        modifyPercentageBtnLabel: 'Modifica la tua scelta',
      },
      additionalCreditSection: {
        textBeforeFigure: 'Grazie alla tua scelta, ricevi un Credito Welfare aggiuntivo pari a:',
        textAfterFigure: '',
      },
      conversionSummaryBannerText: "La stima dell'importo netto convertito in Welfare è:",
      conversionSummaryBannerTextDetails:
        "La stima dell'importo netto convertito in Welfare è: <span class='font-semibold'> {{NETTICREDITO}} netti di Credito Welfare</span> più <span class='font-semibold'> {{NETTIBUSTAPAGA}} netti nella busta paga</span> di luglio 2025",
      rulesAndPrivacyMessage: "Prendi visione dell'informativa privacy e del regolamento, quindi effettua l'adesione al Welfare",
      joinRulesCheckboxes: [
        "Dichiaro di aver preso visione dell'Informativa Privacy",
        "Dichiaro di aver preso visione del Regolamento dell'iniziativa Welfare",
      ],
      bannerStepsTitle: "E poi cosa succede dopo l'adesione?",
      joinBtnLabel: 'Aderisci al Welfare',
      documentsSection: {
        title: 'Documenti utili',
      },
      cancelJoinSection: {
        Errors: {
          GenericSaveError: 'Si è verificato un errore durante la richiesta',
        },
        text: 'Se desideri, puoi annullare la tua adesione al programma Welfare in ogni momento.',
        btnLabel: 'Annulla la tua iscrizione',
        unjoinConfirmationDialog: {
          title: 'Annulla la tua iscrizione',
          text: 'Vuoi davvero annullare la tua iscrizione?',
        },
        unjoinSuccess: {
          trailer:
            '<div class="mb-4 text-[28px] font-bold">Hai scelto di non aderire al Welfare.</div><div class="mb-4">Riceverai una mail di conferma con i dettagli della tua scelta.</div><div>Hai tempo per cambiare idea fino al 7 Luglio 2025.</div>',
          footer: 'Se lo desideri puoi iniziare ad esplorare il catalogo per scoprire tutti i vantaggi del mondo Welfare.',
          goToLandingBtnLabel: 'Torna alla pagina di adesione',
        },
      },
      goBackBtnLabel: 'Indietro',
    },
    MoreDetailsDialog: {
      okBtnLabel: 'Ok, ho capito',
      text: "L'importo da intendersi come indicativo e non vincolante la cui effettiva consuntivazione, in linea con le previsioni contrattuali, avverrà nel mese di luglio 2025.",
      title: 'Maggiori dettagli sul Premio di Risultato',
    },
    Success: {
      trailer: '<div class="mb-4">Complimenti!</div><div class="mb-4">Hai aderito al Welfare.</div>',
      footer:
        '<div class="mb-4">Riceverai una mail di conferma della tua scelta.</div><div class="mb-4">Entro il termine della fase di adesione al Welfare potrai rivedere la tua scelta ed eventualmente modificarla.</div><div class="mb-4">Se lo desideri puoi iniziare a esplorare il catalogo per scoprire tutti i vantaggi del mondo Welfare.</div>',
    },

    Error: {
      text: "Si è verificato un errore durante l'elaborazione della richiesta",
    },
  },
}

const selfRegistrationI18nIt: SelfRegistrationI18n = {
  SelfRegistration: {
    Title: 'Registrazione Utente',
    CloseBtn: 'Chiudi',
    RegisterBtn: 'Registrati',
    Messages: {
      SummarySuccess: 'Registrazione completata',
      DetailSuccess: 'La tua registrazione è stata completata con successo',
      SummaryError: 'Errore di registrazione',
      DuplicatedUserError: 'Utente già registrato',
      GenericError: 'Si è verificato un errore durante la registrazione',
    },
    Errors: {
      Required: 'il campo {{FIELD}} è obbligatorio',
      Invalid: 'il valore inserito non è valido',
      DuplicateEmployeeId: 'Un utente con questa matricola è già presente nel tracciato',
      ExistingEmployeeId: 'Un utente con questa matricola è già stato censito',
      DuplicateTaxCode: 'Un utente con questo codice fiscale è già presente nel tracciato',
      ExistingTaxCode: 'Un utente con questo codice fiscale è già stato censito',
      DuplicateCorporateEmail: 'Un utente con questo indirizzo email è già presente nel tracciato',
      ExistingCorporateEmail: 'Un utente con questo indirizzo email è già stato censito',
      InvalidEmail:
        'Indirizzo email non valido. Sono consentiti solo lettere, numeri, punti, trattini e underscore. Il dominio deve terminare con un suffisso (TLD) composto da 2 a 6 lettere',
      InvalidPhoneNumber:
        'Numero telefonico invalido. Il formato ammesso prevede un prefisso internazionale facoltativo (+ oppure 00 seguito da 1–3 cifre) e un numero di 4–14 cifre senza spazi o simboli speciali.',
      EmployeeIdError:
        'Matricola non valida. Sono consentite lettere maiuscole e minuscole e numeri. Non sono ammessi spazi o simboli speciali.',
      ResidenceAddressInvalid:
        "Indirizzo residenza non valido. Inserire solo lettere (anche accentate), numeri, spazi e i seguenti caratteri speciali: ' - . , /. Non sono ammessi altri simboli.",
      TaxCodeInvalid:
        'Codice fiscale non valido. Inserire 16 caratteri alfanumerici in maiuscolo, senza spazi né simboli. Sono consentite solo lettere maiuscole (A–Z) e cifre (0–9)',
      TaxCodeDataMismatch: 'Codice fiscale non coerente con nome, cognome, data di nascita o sesso inseriti.',
      NameInvalid: '{{FIELD}} non valido. Sono ammessi solo lettere (anche accentate), apostrofi singoli, trattini e spazi.',
      CapInvalid: 'CAP di residenza non valido. Sono ammessi da 1 a 20 caratteri.',
      IbanInvalid: 'IBAN non valido. Inizia con IT seguito da 2 cifre, 1 lettera, 10 cifre e 12 caratteri alfanumerici.',
      MaxLengthField: 'il campo {{FIELD}} non può superare i {{MAX_VALUE}} caratteri.',
    },
    RegistryForm: {
      CompanyData: {
        Title: 'Dati Aziendali',
        EmployeeId: 'Matricola',
        CorporateEmail: 'Email Aziendale',
      },
      RegistryData: {
        Title: 'Dati Anagrafici',
        FirstName: 'Nome',
        LastName: 'Cognome',
        Gender: {
          Label: 'Sesso',
          Data: {
            M: 'Maschio',
            F: 'Femmina',
          },
        },
        BirthDate: {
          Label: 'Data di nascita',
          Format: 'GG/MM/AA',
        },
        TaxCode: 'Codice fiscale',
        PhoneNumber: 'Numero di telefono',
        BirthCountry: 'Stato di nascita',
        BirthProvince: 'Provincia di nascita',
        BirthMunicipality: 'Comune di nascita',
      },
      TermsAndConditions: {
        Title: 'Consensi',
        DocumentPrivacyLabel: 'Informativa privacy',
        PrivacyText:
          'Dichiaro di aver preso visione dell’ Informativa ai sensi del Regolamento 2016/679/UE “Regolamento europeo in materia di protezione dei dati personali” (articoli 13 e seguenti)  e di averne compreso i contenuti',
        PrivacyRequiredText: "La presa visione e l'accettazione dell'Informativa sulla Privacy è obbligatoria",
        PrivacyDocumentRequiredText: "È obbligatorio leggere il documento privacy cliccando sul link 'Informativa privacy'",

        IdentityText:
          'Dichiaro di essere responsabile dei dati inseriti in fase di registrazione alla Piattaforma PWSxTe, nonché dell’illegittima cessione delle agevolazioni in essa presenti, impegnandomi a manlevare e tenere indenne PWS anche giudizialmente da ogni responsabilità, passività, danno, costo e/o spesa (incluse le spese legali) in relazione ad eventuali azioni, pretese e rivalse avanzate anche da terzi e connesse o comunque derivanti dall’utilizzo improprio della Piattaforma da parte dell’utente. Ai sensi e per gli effetti degli artt. 1341 e 1342 c.c., dichiaro altresì di aver preso specifica visione della condizione precedente, di averla compresa e di accettarla espressamente.',
        IdentityRequiredText: 'La dichiarazione di responsabilità dei dati inseriti per la registrazione è obbligatoria',
      },
    },
  },
}

const mealVouchersI18n: MealVouchersI18n = {
  MealVouchers: {
    LoginError: {
      title: 'Attenzione',
      message: 'In questo momento non siamo in grado di caricare i tuoi buoni pasto, riprova più tardi.',
    },
    MealVouchersWallet: {
      title: 'Buoni pasto',
      paymentButton: 'Paga con i buoni pasto',
      updatedAtLabel: 'Aggiornato al',
      activeLabel: 'ATTIVA',
      inactiveLabel: 'NON ATTIVA',
      yourTicketsLabel: 'I tuoi buoni pasto',
      expiryDateLabel: 'Scadenza prossima',
      paymentButtonLabel: 'Paga con i buoni pasto',
      favouriteShops: 'I tuoi negozi preferiti',
      seeAllFavourites: 'Vedi tutto',
      seeAllVouchers: 'Vedi tutti',
      transactionsListTitle: 'Lista transazioni',
      backButtonLabel: 'Indietro',
      vouchersLabel: 'buoni',
    },
    SelectShopStep: {
      title: 'Seleziona il negozio',
      mapView: 'Vista mappa',
      listView: 'Vista elenco',
      paymentButton: 'Paga',
      showDetail: 'Vedi dettaglio',
      shopOpen: 'Aperto',
      shopClosed: 'Chiuso',
      searchShopLabel: 'Cerca negozio',
      positionLabel: 'Posizione attuale',
      locationErrorTitle: "Consenti l'accesso alla posizione",
      locationErrorMessage:
        "Purtroppo hai negato l'accesso alla posizione, per acconsentire visita le impostazioni del tuo browser.",
      positionDialogTitle: 'Posizione',
      positionDialogDescription: 'Inserisci una nuova posizione per cercare negozi al di fuori della tua città',
      newPositionLabel: 'Cerca posizione',
      selectFromMapButton: 'Seleziona dalla mappa',
      positionDialogOrLabel: 'oppure',
      noFavouritesTitle: 'Nessun preferito',
      noFavouritesMessage: 'Ancora non hai aggiunto nessun negozio ai preferiti',
      noResultsTitle: 'Nessun risultato',
      noResultsMessage: 'Prova a modificare i filtri di ricerca.',
      searchAreaButton: 'Cerca in questa zona',
    },
    SelectQuantityStep: {
      title: 'Seleziona la quantità',
      titleOptimalVoucher: "Inserisci l'importo",
      expiryDateLabel: 'Scadenza prossima',
      totalLabel: 'Totale:',
      createOTPButton: 'Paga',
      ticketAmountLabel: 'Da',
      availableAmount: 'Saldo disponibile:',
      automaticSelectionLabel: "Inserisci l'importo per la selezione automatica",
      noSolution: 'Nessuna combinazione trovata per questo importo.',
      calculateButton: 'Procedi',
    },
    PaymentStep: {
      title: 'Pagamento',
      payingLabel: 'Stai pagando',
      insertCodeLabel: 'Inserisci il codice numerico sul POS in cassa',
      cancelButton: 'Annulla il codice',
      otpValidityLabel: 'Il codice che hai generato è valido per i prossimi',
      minutes: 'minuti',
      paymentSuccessTitle: 'Operazione eseguita',
      paymentSuccessMessage: 'Pagamento effettuato con successo',
      closeButton: 'Chiudi',
      paymentErrorTitle: 'Operazione non eseguita',
      paymentErrorMessage: 'Pagamento non effettuato, riprova più tardi.',
      paymentFetchFailedTitle: 'Attenzione',
      paymentFetchFailedMessage:
        'Non riusciamo a mostrare i dettagli in questo momento. Puoi comunque controllare la spesa tra le tue transazioni.',
    },
  },
}

const demoAppI18nIt: DemoAppI18n = {
  AdminPanelTitle: 'Pannello di Amministrazione - Demo App',
  AdminPanelDescription:
    "Attenzione: questa funzionalità è disponibile solo per demo. Cambiando questi parametri verranno ripristinati i dati iniziali dell'utente, compresi ordini e credito.",
  CreditLabel: 'Imposta credito:',
  UserInfoLabel: 'Dati utente:',
  FringeCreditLabel: 'Credito tetto fringe:',
  HideDemoLabel: 'Nascondi demo label',
  NoFringeCreditLabel: 'Credito senza tetto fringe',
  ConfirmButtonLabel: 'Conferma',
  ResetDataLabel: 'Ripristina dati iniziali',
  ResetDataText:
    "Cliccando su questo bottone verranno ripristinati i dati iniziali di ordini, credito, e dati personali dell'utente.",
  ResetDataButtonLabel: 'Ripristina dati',
  FirstNameLabel: 'Nome',
  LastNameLabel: 'Cognome',
  EmailLabel: 'Email',
  CampaignConfigurationLabel: 'Campagne abilitate:',
  LayoutConfigurationLabel: 'Gestisci Layout:',
  SimulateExternalOrderLabel: 'Esempio acquisto ordine su portale esterno',
  SimulateExternalOrderCompletionLabel: 'Simula completamento ordine esterno',
  InformativeBannerDemoAppTitle: 'Demo App',
  CloseButtonLabel: 'Chiudi',
  InformativeBannerDemoApp:
    "Questa è una versione demo dell'applicazione. I prodotti presenti in questa versione sono a scopo dimostrativo.",
  ButtonLabel: 'DEMO APP ',
}

const resources = {
  it: {
    translation: {},
    errors: errorsI18It,
    home: homeI18nIt,
    landing: landingI18nIt,
    catalog: catalogI18nIt,
    news: newsI18nIt,
    userInfo: userInfoI18nIt,
    userAccount: userAccountI18nIt,
    productDetail: productDetailI18nIt,
    shopping: shoppingI18n,
    tutorial: tutorialI18it,
    joinFunnel: joinFunnelI18It,
    proposal: proposalsI18it,
    selfRegistration: selfRegistrationI18nIt,
    mealVouchers: mealVouchersI18n,
    demoApp: demoAppI18nIt,
  },
  en: {
    translation: {},
    errors: errorsI18It,
    home: homeI18nIt,
    landing: landingI18nIt,
    catalog: catalogI18nIt,
    news: newsI18nIt,
    userInfo: userInfoI18nIt,
    userAccount: userAccountI18nIt,
    productDetail: productDetailI18nIt,
    shopping: shoppingI18n,
    tutorial: tutorialI18it,
    joinFunnel: joinFunnelI18It,
    proposal: proposalsI18it,
    selfRegistration: selfRegistrationI18nIt,
    mealVouchers: mealVouchersI18n,
    demoApp: demoAppI18nIt,
  },
} as const satisfies Record<string, I18nResources>

const geti18n = http.get<object, DefaultBodyType, I18nData>(apiBaseUrl + '/i18n', () => {
  return HttpResponse.json({
    namespaces: [
      'translation',
      'errors',
      'home',
      'landing',
      'userInfo',
      'userAccount',
      'productDetail',
      'shopping',
      'joinFunnel',
      'selfRegistration',
    ],
    resources,
  })
})

const getDefaultI18n = http.get<object, DefaultBodyType, DeepPartial<I18nData>>(apiBaseUrl + '/DEFAULT/i18n', () => {
  return HttpResponse.json({
    resources: {
      it: {
        landing: {
          Landing: {
            UserSidePanel: {
              ButtonLabelExit: 'Esci',
            },
          },
        },
      },
    },
  })
})
export const i18nHandlers = [geti18n, getDefaultI18n]
